<template>

  <section class="dp-layout">
    <!-- 
    <section class="left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">

      <!--工具条-->
      <!-- 导出 loading 由全局 exportLoadingMixin（$loading）统一负责，勿再叠自定义遮罩。最后更新：2026-11-02 -->
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!-- 统计与快速筛选：无头像、未绑卡、无设置性别。最后更新：2026-10-15 -->
      <div class="statistics">
        <span>【{{ currentDepartmentName || '全部' }}】总人数: {{ totalCount }}</span>
        <button
          v-if="noAvatarCount !== null && noAvatarCount !== undefined"
          type="button"
          class="stat-no-avatar-pill"
          :class="{ 'is-active': filters && filters.photoStatus === '0' }"
          :title="filters && filters.photoStatus === '0' ? '当前已筛选无头像学生，点击查看全部学生' : '点击自动筛选无头像学生并查询'"
          @click="handleQuickFilterNoAvatar">
          无头像人数: {{ noAvatarCount }}
        </button>
        <button
          v-if="noCardCount !== null && noCardCount !== undefined"
          type="button"
          class="stat-no-avatar-pill"
          :class="{ 'is-active': filters && filters.cardBindStatus === '0' }"
          :title="filters && filters.cardBindStatus === '0' ? '当前已筛选未绑卡学生，点击查看全部学生' : '点击自动筛选未绑卡学生并查询'"
          @click="handleQuickFilterNoCard">
          未绑卡人数: {{ noCardCount }}
        </button>
        <button
          v-if="noSexCount !== null && noSexCount !== undefined"
          type="button"
          class="stat-no-avatar-pill"
          :class="{ 'is-active': filters && filters.sexSetStatus === '0' }"
          :title="filters && filters.sexSetStatus === '0' ? '当前已筛选未设置性别学生，点击查看全部学生' : '点击自动筛选未设置性别学生并查询'"
          @click="handleQuickFilterNoSex">
          无设置性别人数: {{ noSexCount }}
        </button>
      </div>

      <!--列表：包一层让表格吃满剩余高度，表体可横竖滑动。最后更新：2026-08-27 -->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" @row-click="handleRowClick" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="DepartmentName" label="班级" min-width="110" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="学生信息" min-width="200">
          <template slot-scope="scope">
            <div>
              <div>姓名：{{ scope.row.StuName || "-" }}（{{ formatSex(scope.row, null, scope.row.Sex) || "-" }}）</div>
              <div style="color:#909399;">联系电话：{{ scope.row.ContactPhone || "-" }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Id" label="学生ID" min-width="130" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="学号/号次" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="color:#606266;">
              <div>学号：{{ scope.row.StuCode || "-" }}</div>
              <div style="color:#909399;">号次：{{ scope.row.SeatNumber || "-" }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="CardNumber" label="卡号" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="Birthday" label="生日" width="">
        </el-table-column> -->

        <el-table-column prop="HeadPhotoImage" label="头像" align="center" header-align="center" width="72">
          <template slot-scope="scope">
            <oss-media-thumbs
              v-if="scope.row.HeadPhotoImage"
              :media="scope.row.HeadPhotoImage"
              thumb-width="48px"
              thumb-height="48px"
            />
          </template>
        </el-table-column>

        <el-table-column label="类型信息" min-width="140">
          <template slot-scope="scope">
            <div>
              <div>人员类型：{{ scope.row.LiveType || "-" }}</div>
              <div style="color:#909399;">用户类型：{{ formatStuPolitical(scope.row, null, scope.row.StuPolitical) || "-" }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="CreateTime" label="添加时间" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.IsCompany" @click="ShowStudentParent(scope.row)" type="text">监护人</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑人员" :visible.sync="editFormVisible" v-model="editFormVisible"
        :close-on-click-modal="false" width="780px" custom-class="user-form-dialog">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm" autocomplete="off">
          <el-tabs v-model="studentEditTab" class="user-form-tabs">
            <el-tab-pane label="基本信息" name="basic">
              <div class="user-form-tab-pane">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="StuName">
                <el-input v-model="editForm.StuName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所属部门" v-if="options && options.length > 0" prop="Dids">
                <el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids" :options="options"
                  :show-all-levels="false" filterable :key="'edit-' + isResouceShow"
                  :props="$deptCascaderProps" @change="handleChange"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别">
                <el-radio-group v-model="editForm.Sex" v-removeAriaHidden>
                  <el-radio class="radio" :label="1">男</el-radio>
                  <el-radio class="radio" :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生日">
                <el-date-picker type="date" placeholder="选择日期" v-model="editForm.Birthday"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="民族" prop="StuNational">
                <el-input v-model="editForm.StuNational" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="籍贯" prop="HomeTown">
                <el-input v-model="editForm.HomeTown" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="身份证号" prop="IdCard">
                <el-input v-model="editForm.IdCard" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="学号" prop="StuCode">
                <el-input v-model="editForm.StuCode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="号次" prop="SeatNumber">
                <el-input v-model="editForm.SeatNumber" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="身高" prop="Height">
                <el-input v-model="editForm.Height"> <template slot="append">CM</template> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体重" prop="Weight">
                <el-input v-model="editForm.Weight"> <template slot="append">KG</template> </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="封面">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false" accept="image/jpeg,image/jpg,image/png"
                  :show-file-list="false" :on-change="handleAvatarChange">
                  <div v-if="imageUrl" class="avatar-wrapper">
                    <img v-oss-src="imageUrl" class="avatar" />
                    <div class="avatar-mask">
                      <i class="el-icon-delete" @click.stop="handleRemoveAvatar"></i>
                    </div>
                  </div>
                  <i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
                  <i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
                  <div class="avatar-uploader-tip" v-if="!imageUrl && !imageLoadding">
                  </div>
                </el-upload>
                <div v-if="imageSizeKb > 0" class="avatar-size-tip" :class="{ 'is-over': imageSizeKb > 500 }">
                  图片大小：{{ imageSizeKb }} KB
                </div>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="账号与卡务" name="account">
              <div class="user-form-tab-pane">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="卡号" prop="CardNumber">
                <el-input v-model="editForm.CardNumber" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户类型" prop="StuPolitical">
                <el-select v-model="editForm.StuPolitical" placeholder="请选择用户类型">
                  <el-option label="普通" value=""></el-option>
                  <el-option label="专用" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="14">
              <el-form-item v-for="(domain, index) in editForm.domains" :label="'备用卡号' + index" :key="domain.key"
                :prop="'domains.' + index + '.value'">
                <div style="display: flex;">
                  <el-input v-model="domain.value" :disabled="domain.type == 1 ? true : false"></el-input>
                  <el-button v-if="domain.type == 1" type="danger" @click="removeDomain(domain)"
                    :loading="addLoading">解绑</el-button>

                  <el-button v-if="domain.type == 0" type="primary" @click="submitForm(domain)"
                    :loading="addLoading">绑定</el-button>

                  <el-button v-if="domain.type == 0" type="danger" @click="delDomain(domain)"
                    :loading="addLoading">删除</el-button>

                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button @click="addDomain">新增卡号</el-button>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="血型" prop="BloodType">
                <el-select v-model="editForm.BloodType" placeholder="请选择血型">
                  <el-option label="未知" value=""></el-option>
                  <el-option label="A型" value="A"></el-option>
                  <el-option label="B型" value="B"></el-option>
                  <el-option label="O型" value="0"></el-option>
                  <el-option label="AB型" value="AB"></el-option>
                  <el-option label="RH型" value="RH"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人员类型" prop="LiveTypeId">
                <el-select v-model="liveTypeId" placeholder="请选择人员类型">
                  <el-option v-for="item in liveTypeList" :key="item.LiveTypeId" :label="item.LiveTypeName"
                    :value="item.LiveTypeId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="人员账号" prop="Account">
                <el-input v-model="editForm.Account" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="登录密码" prop="Password">
                <password-input v-model="editForm.Password"></password-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="联系人" prop="ContactPerson">
                <el-input v-model="editForm.ContactPerson" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="ContactPhone">
                <el-input v-model="editForm.ContactPhone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="地址">
                <el-input type="textarea" v-model="editForm.Address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="第三方账号" prop="ThirdPartyCode">
                <el-input v-model="editForm.ThirdPartyCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="学籍异动" name="enrollment">
              <div class="user-form-tab-pane enrollment-tab">
                <el-alert
                  title="休学留在主表，家长仍可关联；转学/退学将迁入归档。办理后学生会离开在读花名册。"
                  type="info"
                  :closable="false"
                  show-icon
                  style="margin-bottom: 16px;"
                />
                <el-form-item label="异动类型">
                  <el-radio-group v-model="enrollmentTargetStatus">
                    <el-radio :label="1">休学</el-radio>
                    <el-radio :label="2">转学</el-radio>
                    <el-radio :label="3">退学</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="办理原因" required>
                  <el-input
                    v-model="enrollmentReason"
                    type="textarea"
                    :rows="4"
                    placeholder="请填写办理原因"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="warning" :loading="enrollmentSaving" @click="submitEnrollmentChange">
                    确认办理
                  </el-button>
                </el-form-item>
              </div>
            </el-tab-pane>
          </el-tabs>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button v-if="studentEditTab !== 'enrollment'" type="primary" @click.native="editSubmit"
            :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增人员" :visible.sync="addFormVisible" v-model="addFormVisible"
        :close-on-click-modal="false" width="780px" custom-class="user-form-dialog">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-dynamic" autocomplete="off">
          <el-tabs v-model="studentAddTab" class="user-form-tabs">
            <el-tab-pane label="基本信息" name="basic">
              <div class="user-form-tab-pane">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="StuName">
                <el-input v-model="addForm.StuName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属部门" v-if="options && options.length > 0" prop="Dids">
                <el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids" :options="options"
                  :show-all-levels="false" filterable :key="'add-' + isResouceShow"
                  :props="$deptCascaderProps" @change="handleChange"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别">
                <el-radio-group v-model="addForm.Sex" v-removeAriaHidden>
                  <el-radio class="radio" :label="1">男</el-radio>
                  <el-radio class="radio" :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生日">
                <el-date-picker type="date" placeholder="选择日期" v-model="addForm.Birthday"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="民族" prop="StuNational">
                <el-input v-model="addForm.StuNational" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="籍贯" prop="HomeTown">
                <el-input v-model="addForm.HomeTown" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="身份证号" prop="IdCard">
                <el-input v-model="addForm.IdCard" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="学号" prop="StuCode">
                <el-input v-model="addForm.StuCode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="号次" prop="SeatNumber">
                <el-input v-model="addForm.SeatNumber" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="身高" prop="Height">
                <el-input v-model="addForm.Height"> <template slot="append">CM</template> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体重" prop="Weight">
                <el-input v-model="addForm.Weight"> <template slot="append">KG</template> </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="封面">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false" accept="image/jpeg,image/jpg,image/png"
                  :show-file-list="false" :on-change="handleAvatarChange">
                  <img v-if="imageUrl" v-oss-src="imageUrl" class="avatar" />
                  <i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
                  <i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
                  <div class="avatar-uploader-tip" v-if="!imageUrl && !imageLoadding">
                  </div>
                </el-upload>
                <div v-if="imageSizeKb > 0" class="avatar-size-tip" :class="{ 'is-over': imageSizeKb > 500 }">
                  图片大小：{{ imageSizeKb }} KB
                </div>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="账号与卡务" name="account">
              <div class="user-form-tab-pane">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="卡号" prop="CardNumber">
                <el-input v-model="addForm.CardNumber" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="用户类型" prop="StuPolitical">
                <el-select v-model="addForm.StuPolitical" placeholder="请选择用户类型">
                  <el-option label="普通" value=""></el-option>
                  <el-option label="专用" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="血型" prop="BloodType">
                <el-select v-model="addForm.BloodType" placeholder="请选择血型">
                  <el-option label="未知" value=""></el-option>
                  <el-option label="A型" value="A"></el-option>
                  <el-option label="B型" value="B"></el-option>
                  <el-option label="O型" value="0"></el-option>
                  <el-option label="AB型" value="AB"></el-option>
                  <el-option label="RH型" value="RH"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人员类型" prop="LiveTypeId">
                <el-select v-model="liveTypeId" placeholder="请选择人员类型">
                  <el-option v-for="item in liveTypeList" :key="item.LiveTypeId" :label="item.LiveTypeName"
                    :value="item.LiveTypeId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="人员账号" prop="Account">
                <el-input v-model="addForm.Account" auto-complete="off" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="登录密码" prop="Password">
                <password-input :key="'person-add-pwd-' + addPwdInputKey" v-model="addForm.Password"></password-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="联系人" prop="ContactPerson">
                <el-input v-model="addForm.ContactPerson" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="ContactPhone">
                <el-input v-model="addForm.ContactPhone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="地址">
                <el-input type="textarea" v-model="addForm.Address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="第三方账号" prop="ThirdPartyCode">
                <el-input v-model="addForm.ThirdPartyCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 监护人管理弹窗：固定适中高度，表格吃满剩余空间。最后修改：2026-10-20 -->
      <el-dialog title="监护人管理" :visible.sync="guardianVisible" width="980px" append-to-body destroy-on-close
        :close-on-click-modal="false" custom-class="guardian-manage-dialog">
        <StudentParentManagement :isDialog="true" :stuId="currentUserId" :stuName="currentStudentName" />
      </el-dialog>

      <!-- 批量更改班级 -->
      <el-dialog title="批量更改班级" :visible.sync="batchChangeClassDialogVisible" width="640px"
        :close-on-click-modal="false">
        <el-form label-width="110px">
          <el-form-item label="匹配方式">
            <el-radio-group v-model="batchChangeClassForm.identifierType">
              <el-radio label="StudentId">按学生ID</el-radio>
              <el-radio label="StuCode">按学号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="batchChangeClassForm.identifierType === 'StuCode' ? '学号列表' : '学生ID列表'">
            <el-input type="textarea" :rows="8" v-model="batchChangeClassForm.studentIdsText"
              :placeholder="batchChangeClassForm.identifierType === 'StuCode' ? '请输入学号，支持“学号,姓名”一行一条（例如：231236,张三）' : '请输入学生ID，支持一行一个，或使用逗号/中文逗号/分号/空格分隔'">
            </el-input>
          </el-form-item>
          <el-form-item label="目标班级ID">
            <div style="display:flex;gap:8px;align-items:center;">
              <el-select v-model="batchChangeClassForm.targetClassId" style="flex:1;" filterable clearable
                placeholder="可输入班级ID/名称搜索并选择" @change="handleBatchTargetClassSelect">
                <el-option v-for="item in batchClassOptions" :key="item.id" :label="`${item.name}（ID:${item.id}）`"
                  :value="item.id.toString()">
                </el-option>
              </el-select>
              <el-button type="primary" :loading="classQueryLoading" @click="queryBatchTargetClass">查询班级</el-button>
            </div>
          </el-form-item>
          <el-form-item label="班级名称">
            <el-input v-model="batchChangeClassForm.targetClassName" disabled placeholder="查询后自动回显"></el-input>
          </el-form-item>
        </el-form>

        <div v-if="batchChangeClassResult" style="margin-top:10px;">
          <el-alert
            :title="`处理完成：共${batchChangeClassResult.Total || 0}条，成功${batchChangeClassResult.SuccessCount || 0}条，失败${batchChangeClassResult.FailCount || 0}条`"
            type="info" :closable="false">
          </el-alert>
          <div style="margin-top:8px;" v-if="batchChangeClassResult.FailCount > 0">
            <el-button type="text" @click="openBatchChangeFailedDialog">查看失败明细</el-button>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="batchChangeClassDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="batchChangeClassLoading" @click="submitBatchChangeClass">确定保存</el-button>
        </span>
      </el-dialog>
      <el-dialog title="批量改班失败明细" :visible.sync="batchChangeFailedDialogVisible" width="760px">
        <div style="display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:10px;">
          <div style="font-size:13px;color:#606266;">
            共 <span style="color:var(--btn-primary, #2563eb);font-weight:600;">{{ batchChangeFailedItems.length }}</span> 条，
            筛选后 <span style="color:#67C23A;font-weight:600;">{{ batchChangeFailedFilteredItems.length }}</span> 条
          </div>
          <el-input v-model.trim="batchChangeFailedKeyword" clearable placeholder="搜索：输入值/学号/姓名/失败原因"
            size="small" style="width:320px;" @input="handleBatchFailedKeywordChange">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div style="max-height:460px;overflow:auto;padding-right:4px;">
          <el-card v-for="(item, index) in batchChangeFailedPagedItems" :key="index" shadow="never"
            style="margin-bottom:10px;border:1px solid #EBEEF5;">
            <div style="font-weight:600;color:#303133;margin-bottom:8px;">第{{ (batchChangeFailedPage - 1) * batchChangeFailedPageSize + index + 1 }}条</div>
            <div style="line-height:1.9;color:#606266;">
              <div>
                <span style="color:#909399;">输入值：</span>{{ item.InputValue }}
                <span style="color:#DCDFE6;padding:0 8px;">|</span>
                <span style="color:#909399;">学生ID：</span>{{ item.StudentId }}
                <span style="color:#DCDFE6;padding:0 8px;">|</span>
                <span style="color:#909399;">学号：</span>{{ item.StuCode }}
                <span style="color:#DCDFE6;padding:0 8px;">|</span>
                <span style="color:#909399;">姓名：</span>{{ item.StudentName }}
              </div>
              <div><span style="color:#909399;">失败原因：</span>{{ item.Message }}</div>
            </div>
          </el-card>
          <el-empty v-if="!batchChangeFailedFilteredItems.length" description="暂无失败明细"></el-empty>
        </div>
        <div style="margin-top:8px;text-align:right;" v-if="batchChangeFailedFilteredItems.length > batchChangeFailedPageSize">
          <el-pagination
            small
            :current-page="batchChangeFailedPage"
            :page-size="batchChangeFailedPageSize"
            :total="batchChangeFailedFilteredItems.length"
            layout="prev, pager, next"
            @current-change="handleBatchFailedPageChange">
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="batchChangeFailedDialogVisible = false">我知道了</el-button>
        </span>
      </el-dialog>

      <import-result-dialog
        :visible.sync="studentImportResultDialogVisible"
        :result="importResult"
      />

      <import-result-dialog
        :visible.sync="photoImportResultDialogVisible"
        :result="photoImportResult"
      />

      <!-- 导入学生：选择文件 -->
      <el-dialog :visible.sync="studentImportDialogVisible" width="860px" custom-class="person-import-dialog"
        :close-on-click-modal="false" append-to-body @closed="onStudentImportDialogClosed">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-user"></i></span>
          <div>
            <strong>批量导入学生</strong>
            <p>下载模板填写后上传，核对无误再确认写入</p>
          </div>
        </div>
        <div class="pi-body">
          <div class="pi-steps">
            <div class="pi-step">
              <span class="pi-step__no">1</span>
              <div><strong>下载模板</strong><em>按列填写学生信息</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">2</span>
              <div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">3</span>
              <div><strong>核对导入</strong><em>预览后再确认写入</em></div>
            </div>
          </div>
          <button type="button" class="pi-template-card" @click="downloadStudentImportTemplate">
            <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
            <span class="pi-template-card__meta">
              <strong>学生批量导入模板.xlsx</strong>
              <em>含班级、姓名、学号、卡号、第三方ID 等列；学校以顶部所选为准</em>
            </span>
            <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
          </button>
          <el-upload :key="'stu-upload-' + studentImportUploadKey" ref="studentImportUpload"
            class="pi-upload" drag action="#" :auto-upload="false" :limit="1" :show-file-list="false"
            accept=".xlsx,.xls" :on-change="onStudentImportFileChange" :on-remove="onStudentImportFileRemove"
            :on-exceed="onStudentImportExceed">
            <div v-if="studentImportFileRaw" class="pi-upload__file">
              <i class="el-icon-success pi-upload__ok"></i>
              <div>
                <strong>{{ studentImportFileRaw.name }}</strong>
                <em>已选择，点击「解析并预览」进入核对</em>
              </div>
            </div>
            <div v-else class="pi-upload__empty">
              <i class="el-icon-upload2"></i>
              <strong>点击选择或拖拽 Excel 到此处</strong>
              <em>仅支持标准 .xlsx / .xls 文件</em>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="studentImportDialogVisible = false">关闭</el-button>
          <el-button type="primary" icon="el-icon-view" :disabled="!studentImportFileRaw"
            :loading="studentImportParsing" @click="parseStudentImportFile">
            解析并预览
          </el-button>
        </div>
      </el-dialog>

      <!-- 导入监护人：选择文件 -->
      <el-dialog :visible.sync="parentImportDialogVisible" width="860px" custom-class="person-import-dialog"
        :close-on-click-modal="false" append-to-body @closed="onParentImportDialogClosed">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-s-custom"></i></span>
          <div>
            <strong>批量导入监护人</strong>
            <p>
              {{ currentDepartmentName ? `当前范围：${currentDepartmentName}` : '请先选择具体部门' }}
              · 按当前部门导出带学生信息的模板后填写
            </p>
          </div>
        </div>
        <div class="pi-body">
          <div class="pi-steps">
            <div class="pi-step">
              <span class="pi-step__no">1</span>
              <div><strong>下载模板</strong><em>含本部门学生与家长列</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">2</span>
              <div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">3</span>
              <div><strong>核对导入</strong><em>预览后再确认写入</em></div>
            </div>
          </div>
          <button type="button" class="pi-template-card" :disabled="exportLoading" @click="downloadParentTemplate">
            <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
            <span class="pi-template-card__meta">
              <strong>导入监护人模板.xlsx</strong>
              <em>按当前左侧选中部门导出；填写家长1~5 后回传</em>
            </span>
            <span class="pi-template-card__action">
              <i class="el-icon-loading" v-if="exportLoading"></i>
              <template v-else><i class="el-icon-download"></i>下载模板</template>
            </span>
          </button>
          <el-upload :key="'parent-upload-' + parentImportUploadKey" ref="parentImportUpload"
            class="pi-upload" drag action="#" :auto-upload="false" :limit="1" :show-file-list="false"
            accept=".xlsx,.xls" :on-change="onParentImportFileChange" :on-remove="onParentImportFileRemove"
            :on-exceed="onParentImportExceed">
            <div v-if="parentImportFileRaw" class="pi-upload__file">
              <i class="el-icon-success pi-upload__ok"></i>
              <div>
                <strong>{{ parentImportFileRaw.name }}</strong>
                <em>已选择，点击「解析并预览」进入核对</em>
              </div>
            </div>
            <div v-else class="pi-upload__empty">
              <i class="el-icon-upload2"></i>
              <strong>点击选择或拖拽 Excel 到此处</strong>
              <em>仅支持标准 .xlsx / .xls 文件</em>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="parentImportDialogVisible = false">关闭</el-button>
          <el-button type="primary" icon="el-icon-view" :disabled="!parentImportFileRaw"
            :loading="parentImportParsing" @click="parseParentImportFile">
            解析并预览
          </el-button>
        </div>
      </el-dialog>

      <!-- 学生导入核对 -->
      <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="78%"
        custom-class="person-import-dialog" append-to-body
        :before-close="(done) => { this.backToStudentImportSelect(); done(); }">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div>
            <strong>学生导入核对</strong>
            <p>共 {{ outputs.length }} 条，确认无误后写入系统</p>
          </div>
        </div>
        <el-table :data="outputs" ref="outputs_table" class="pi-preview-table" border stripe
          style="width: 100%" max-height="520">
          <el-table-column prop="Department" label="所属部门" min-width="120" show-overflow-tooltip />
          <el-table-column prop="StudentId" label="学生ID" width="100" show-overflow-tooltip />
          <el-table-column prop="Name" label="姓名" width="90" show-overflow-tooltip />
          <el-table-column prop="StuCode" label="学号" width="100" show-overflow-tooltip />
          <el-table-column prop="SeatNumber" label="号次" width="70" />
          <el-table-column prop="Sex" label="性别" width="60" />
          <el-table-column prop="ContactPhone" label="联系电话" width="120" show-overflow-tooltip />
          <el-table-column prop="Card" label="卡号" width="110" show-overflow-tooltip />
          <el-table-column prop="PhotoPath" label="照片路径" min-width="120" show-overflow-tooltip />
          <el-table-column prop="Type" label="类型" width="80" />
          <el-table-column prop="StuPolitical" label="用户类型" width="90" />
          <el-table-column prop="ThirdPartyCode" label="第三方ID" width="120" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" align="center" width="90">
            <template slot-scope="scope">
              <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="pi-footer">
          <el-button @click="backToStudentImportSelect">返回上一步</el-button>
          <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">
            确认导入
          </el-button>
        </div>
      </el-dialog>

      <!-- 监护人导入核对 -->
      <el-dialog :visible.sync="parentExcelShow" :close-on-click-modal="false" width="86%"
        custom-class="person-import-dialog" append-to-body
        :before-close="(done) => { this.backToParentImportSelect(); done(); }">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div>
            <strong>监护人导入核对</strong>
            <p>共 {{ parentOutputs.length }} 条学生行，确认无误后写入系统</p>
          </div>
        </div>
        <el-table :data="parentOutputs" ref="parent_outputs_table" class="pi-preview-table" border stripe
          style="width: 100%" max-height="520">
          <el-table-column prop="StuId" label="学生ID" width="100" show-overflow-tooltip />
          <el-table-column prop="StuName" label="学生姓名" width="90" show-overflow-tooltip />
          <el-table-column prop="ClassName" label="班级名称" min-width="110" show-overflow-tooltip />
          <el-table-column prop="Parent1Id" label="家长1记录ID" width="110" show-overflow-tooltip />
          <el-table-column prop="Parent1Name" label="家长1姓名" width="90" />
          <el-table-column prop="Parent1RelationDesc" label="家长1关系" width="90" />
          <el-table-column prop="Parent1Msisdn" label="家长1电话" width="110" />
          <el-table-column prop="Parent1Plates" label="家长1车牌" min-width="110" show-overflow-tooltip />
          <el-table-column prop="Parent1ThirdPartyCode" label="家长1第三方ID" width="120" show-overflow-tooltip />
          <el-table-column prop="Parent2Id" label="家长2记录ID" width="110" show-overflow-tooltip />
          <el-table-column prop="Parent2Name" label="家长2姓名" width="90" />
          <el-table-column prop="Parent2RelationDesc" label="家长2关系" width="90" />
          <el-table-column prop="Parent2Msisdn" label="家长2电话" width="110" />
          <el-table-column prop="Parent2Plates" label="家长2车牌" min-width="110" show-overflow-tooltip />
          <el-table-column prop="Parent2ThirdPartyCode" label="家长2第三方ID" width="120" show-overflow-tooltip />
          <el-table-column prop="Parent3Id" label="家长3记录ID" width="110" show-overflow-tooltip />
          <el-table-column prop="Parent3Name" label="家长3姓名" width="90" />
          <el-table-column prop="Parent3RelationDesc" label="家长3关系" width="90" />
          <el-table-column prop="Parent3Msisdn" label="家长3电话" width="110" />
          <el-table-column prop="Parent3Plates" label="家长3车牌" min-width="110" show-overflow-tooltip />
          <el-table-column prop="Parent3ThirdPartyCode" label="家长3第三方ID" width="120" show-overflow-tooltip />
          <el-table-column prop="Parent4Id" label="家长4记录ID" width="110" show-overflow-tooltip />
          <el-table-column prop="Parent4Name" label="家长4姓名" width="90" />
          <el-table-column prop="Parent4RelationDesc" label="家长4关系" width="90" />
          <el-table-column prop="Parent4Msisdn" label="家长4电话" width="110" />
          <el-table-column prop="Parent4Plates" label="家长4车牌" min-width="110" show-overflow-tooltip />
          <el-table-column prop="Parent4ThirdPartyCode" label="家长4第三方ID" width="120" show-overflow-tooltip />
          <el-table-column prop="Parent5Id" label="家长5记录ID" width="110" show-overflow-tooltip />
          <el-table-column prop="Parent5Name" label="家长5姓名" width="90" />
          <el-table-column prop="Parent5RelationDesc" label="家长5关系" width="90" />
          <el-table-column prop="Parent5Msisdn" label="家长5电话" width="110" />
          <el-table-column prop="Parent5Plates" label="家长5车牌" min-width="110" show-overflow-tooltip />
          <el-table-column prop="Parent5ThirdPartyCode" label="家长5第三方ID" width="120" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" align="center" width="90">
            <template slot-scope="scope">
              <el-button type="text" class="pi-row-del" @click="removeParentImport(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="pi-footer">
          <el-button @click="backToParentImportSelect">返回上一步</el-button>
          <el-button type="primary" icon="el-icon-upload2" :disabled="!parentOutputs.length"
            @click="SavaParentImport">确认导入</el-button>
        </div>
      </el-dialog>

      <LocalAvatarMigrateDialog
        :visible.sync="localAvatarMigrateVisible"
        person-type="student"
        @done="onLocalAvatarMigrateDone">
      </LocalAvatarMigrateDialog>
      <HeadPhotoCompressDialog
        :visible.sync="headPhotoCompressVisible"
        person-type="student"
        @done="onHeadPhotoCompressDone">
      </HeadPhotoCompressDialog>

      <StudentQrCodeDialog
        :visible.sync="studentQrCodeDialogVisible"
        :department-id="DepartmentId"
        :department-name="currentDepartmentName"
        :filters="filters">
      </StudentQrCodeDialog>

      <!-- 重复学生检测（同钉钉 ThirdPartyCode / 同姓名）。创建于 2026-09-03；最后更新：2026-09-15 -->
      <el-dialog
        title="重复学生检测"
        :visible.sync="duplicateDialogVisible"
        width="1250px"
        :close-on-click-modal="false"
        append-to-body
        custom-class="duplicate-student-dialog">
        <div class="duplicate-tip">
          <template v-if="isDingTalkSchool">
            按「同钉钉 userid」与「同姓名」检测多条档案；可用「按所选部门」只扫当前班级/年级。优先保留有业务/班级与钉钉一致的；钉钉重复组可「对照钉钉」后「合并」。同名组请人工核对后删除僵尸档。有余额无法删除。
          </template>
          <template v-else>
            按「同姓名」检测多条在读档案（本校无钉钉也可）；可用「按所选部门」只扫当前班级/年级。请结合班级、卡号、监护人等人工核对后删除僵尸档。有余额无法删除。
          </template>
        </div>
        <div class="duplicate-toolbar">
          <el-input
            v-model="duplicateKeyword"
            clearable
            size="small"
            placeholder="搜索姓名 / 第三方账号 / 班级 / 学生ID"
            prefix-icon="el-icon-search"
            class="duplicate-search"
            @keyup.enter.native="handleDuplicateSearch"
            @clear="handleDuplicateClear"
          />
          <el-button type="primary" size="small" icon="el-icon-search" :loading="duplicateLoading" @click="handleDuplicateSearch">查询</el-button>
          <el-switch
            v-model="duplicateScopeByDepartment"
            class="duplicate-scope-switch"
            active-text="按所选部门"
            inactive-text="全校"
            @change="handleDuplicateScopeChange"
          />
          <div class="duplicate-summary">
            <el-tag type="info" size="small">重复组数：{{ duplicateSummary.groupCount }}</el-tag>
            <el-tag type="info" size="small">涉及学生：{{ duplicateSummary.studentCount }}</el-tag>
          </div>
        </div>
        <div class="duplicate-list-panel" v-loading="duplicateLoading">
          <el-empty v-if="!duplicateLoading && duplicateGroups.length === 0" description="未发现重复学生" />
          <el-collapse v-model="duplicateActiveGroups" class="duplicate-collapse">
            <el-collapse-item
              v-for="group in duplicateGroups"
              :key="duplicateGroupUiKey(group)"
              :name="duplicateGroupUiKey(group)">
              <template slot="title">
                <span class="duplicate-group-title">
                  {{ group.Items[0] ? (group.Items[0].StuName || '-') : '-' }}
                  <template v-if="isDuplicateNameGroup(group)">（同姓名）</template>
                  <template v-else>（ThirdPartyCode: {{ group.GroupKey || '-' }}）</template>
                </span>
                <el-tag size="mini" :type="isDuplicateNameGroup(group) ? 'primary' : 'warning'">
                  {{ group.GroupTypeText || (isDuplicateNameGroup(group) ? '同姓名' : '同钉钉ID') }} · {{ group.DuplicateCount }} 条
                </el-tag>
                <el-button
                  v-if="isDingTalkSchool && (!isDuplicateNameGroup(group) || duplicateGroupDingCode(group))"
                  type="text"
                  size="mini"
                  icon="el-icon-connection"
                  class="duplicate-ding-btn"
                  :loading="duplicateDingLoadingKey === duplicateGroupUiKey(group)"
                  @click.stop="compareDuplicateWithDingTalk(group)">
                  对照钉钉
                </el-button>
                <el-button
                  v-if="isDingTalkSchool && group._dingCompare && group._dingCompare.CanMerge"
                  type="text"
                  size="mini"
                  icon="el-icon-sort"
                  class="duplicate-merge-btn"
                  :loading="duplicateMergeLoadingKey === duplicateGroupUiKey(group)"
                  @click.stop="mergeDuplicateGroup(group)">
                  合并
                </el-button>
                <span
                  v-if="group._dingCompare && group._dingCompare.Found"
                  class="duplicate-ding-summary"
                  :title="formatDuplicateDingSummary(group._dingCompare)"
                  @click.stop
                >
                  <span class="duplicate-ding-line">钉钉班级：{{ group._dingCompare.DingClassName || group._dingCompare.DingClassId }}</span>
                  <span
                    v-if="group._dingCompare.Guardians && group._dingCompare.Guardians.length"
                    class="duplicate-ding-line"
                  >
                    监护人：
                    <span
                      v-for="(g, gi) in group._dingCompare.Guardians"
                      :key="'g-' + gi + '-' + (g.UserId || '')"
                    >{{ g.Name || '未命名' }}{{ g.RelationName ? '(' + g.RelationName + ')' : '' }}<em v-if="g.UserId" class="duplicate-ding-uid">钉钉ID:{{ g.UserId }}</em>{{ gi < group._dingCompare.Guardians.length - 1 ? '、' : '' }}</span>
                  </span>
                </span>
              </template>
              <el-table :data="group.Items" border size="mini" class="duplicate-table" style="width: 100%">
                <el-table-column prop="StudentId" label="学生ID" min-width="150" show-overflow-tooltip />
                <el-table-column prop="StuName" label="姓名" min-width="100" show-overflow-tooltip />
                <el-table-column label="卡号" min-width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.CardNumber || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="DepartmentName" label="班级" min-width="160" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.DepartmentName || '-' }}
                    <el-tag v-if="scope.row.ClassMatchDingTalk === true" size="mini" type="success" style="margin-left:2px;">班一致</el-tag>
                    <el-tag v-else-if="scope.row.ClassMatchDingTalk === false" size="mini" type="danger" style="margin-left:2px;">班不一致</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="SchoolStatusText" label="学籍" width="50" align="center" />
                <el-table-column label="监护人" width="78" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" class="duplicate-parent-link" @click.stop="showDuplicateStudentParent(scope.row)">
                      {{ scope.row.ParentCount }}
                      <span v-if="scope.row.ParentNameMismatchCount > 0" class="duplicate-parent-mismatch">
                        (错{{ scope.row.ParentNameMismatchCount }})
                      </span>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="余额" width="62" align="right">
                  <template slot-scope="scope">
                    <span :style="{ color: scope.row.UserBalance > 0 ? '#F56C6C' : '#67C23A' }">
                      {{ formatDuplicateBalance(scope.row.UserBalance) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="业务" width="70" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="formatDuplicateBizSummary(scope.row)">{{ formatDuplicateBizSummary(scope.row) }}</span>
                    <span v-else style="color:#94a3b8;">无</span>
                  </template>
                </el-table-column>
                <el-table-column label="风险" min-width="118" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-tooltip
                      :content="(scope.row.RiskTags || []).join('、')"
                      placement="top"
                      :disabled="!(scope.row.RiskTags && scope.row.RiskTags.length)">
                      <div class="duplicate-risk-cell">
                        <el-tag
                          v-for="(tag, index) in scope.row.RiskTags"
                          :key="index"
                          size="mini"
                          :type="duplicateRiskTagType(tag)"
                          class="duplicate-risk-tag">{{ tag }}</el-tag>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="CreateTime" label="创建" min-width="150" show-overflow-tooltip />
                <el-table-column label="建议" width="108" align="center" class-name="duplicate-col-suggest">
                  <template slot-scope="scope">
                    <el-tooltip :content="scope.row.RecommendReason || ''" placement="top" :disabled="!scope.row.RecommendReason">
                      <el-tag size="mini" :type="duplicateRecommendTagType(scope.row.RecommendAction)">
                        {{ scope.row.RecommendText || '需对照' }}
                      </el-tag>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="90" align="center" class-name="duplicate-col-action">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" class="duplicate-del-btn" @click="removeDuplicateStudent(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-show="duplicateSummary.groupCount > 0" class="duplicate-pager">
          <el-pagination
            local-paging
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="duplicatePageSize"
            :total="duplicateSummary.groupCount"
            :current-page.sync="duplicatePage"
            @size-change="handleDuplicateSizeChange"
            @current-change="handleDuplicatePageChange"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="duplicateDialogVisible = false">关 闭</el-button>
          <el-button type="primary" :loading="duplicateLoading" @click="duplicateStudentCheck">刷 新</el-button>
        </span>
      </el-dialog>

      <!-- 导出学生照片：命名规则 -->
      <el-dialog
        :visible.sync="photoNameDialogVisible"
        width="560px"
        :close-on-click-modal="false"
        append-to-body
        custom-class="esp-dialog">
        <div slot="title" class="esp-dialog-title">
          <span class="esp-dialog-title__icon"><i class="el-icon-picture-outline"></i></span>
          <div>
            <strong>导出学生照片</strong>
            <p class="esp-dialog-title__scope">
              当前范围：
              <em>{{ currentDepartmentName || '未选择部门' }}</em>
              <span>（含下级部门）</span>
            </p>
            <p>选择 ZIP 内文件命名规则，照片将按班级文件夹存放</p>
          </div>
        </div>
        <div class="esp-body">
          <p class="esp-section-label">命名规则</p>
          <div class="esp-option-grid" role="radiogroup" aria-label="照片命名规则">
            <button
              v-for="item in photoNamePresetOptions"
              :key="item.value"
              type="button"
              class="esp-option"
              :class="{ 'is-active': photoNamePreset === item.value }"
              role="radio"
              :aria-checked="photoNamePreset === item.value ? 'true' : 'false'"
              @click="selectPhotoNamePreset(item.value)">
              <span class="esp-option__title">{{ item.label }}</span>
              <span class="esp-option__desc">{{ item.desc }}</span>
              <span v-if="item.recommended" class="esp-option__badge">推荐</span>
              <span class="esp-option__check" aria-hidden="true"><i class="el-icon-check"></i></span>
            </button>
          </div>

          <div v-if="photoNamePreset === 'custom'" class="esp-custom">
            <p class="esp-custom__hint">勾选字段按「姓名 → 学生ID → 学号」用下划线拼接</p>
            <div class="esp-chips" role="group" aria-label="自由搭配字段">
              <button
                v-for="chip in photoNameCustomChipOptions"
                :key="chip.value"
                type="button"
                class="esp-chip"
                :class="{ 'is-active': photoNameCustomParts.indexOf(chip.value) > -1 }"
                :aria-pressed="photoNameCustomParts.indexOf(chip.value) > -1 ? 'true' : 'false'"
                @click="togglePhotoNameCustomPart(chip.value)">
                <span class="esp-chip__dot" aria-hidden="true"></span>
                {{ chip.label }}
              </button>
            </div>
          </div>

          <div class="esp-preview">
            <span class="esp-preview__icon" aria-hidden="true"><i class="el-icon-document"></i></span>
            <div class="esp-preview__meta">
              <span class="esp-preview__label">预览示例</span>
              <span
                class="esp-preview__name"
                :class="{ 'is-empty': !resolvedPhotoNameParts.length }">{{ photoNamePreview }}</span>
            </div>
          </div>
        </div>
        <div slot="footer" class="esp-footer">
          <el-button @click="photoNameDialogVisible = false">取消</el-button>
          <el-button type="primary" icon="el-icon-download" @click="confirmExportStudentPhotosZip">开始导出</el-button>
        </div>
      </el-dialog>

      <!-- 导入学生照片：命名规则 + ZIP 上传（左右布局） -->
      <el-dialog
        :visible.sync="photoImportDialogVisible"
        width="820px"
        :close-on-click-modal="false"
        append-to-body
        custom-class="esp-dialog esp-dialog--import">
        <div slot="title" class="esp-dialog-title">
          <span class="esp-dialog-title__icon"><i class="el-icon-upload2"></i></span>
          <div>
            <strong>导入学生照片</strong>
            <p class="esp-dialog-title__scope">
              当前范围：
              <em>{{ currentDepartmentName || '未选择部门' }}</em>
              <span>（含下级部门）</span>
            </p>
            <p>左侧选命名规则，右侧上传 ZIP；照片须按班级文件夹存放</p>
          </div>
        </div>
        <div class="esp-body esp-body--import">
          <div class="esp-import-layout">
            <div class="esp-import-layout__left">
              <p class="esp-section-label">命名规则</p>
              <div class="esp-option-grid" role="radiogroup" aria-label="照片导入命名规则">
                <button
                  v-for="item in photoNamePresetOptions"
                  :key="'imp-' + item.value"
                  type="button"
                  class="esp-option"
                  :class="{ 'is-active': photoImportNamePreset === item.value }"
                  role="radio"
                  :aria-checked="photoImportNamePreset === item.value ? 'true' : 'false'"
                  @click="selectPhotoImportNamePreset(item.value)">
                  <span class="esp-option__title">{{ item.label }}</span>
                  <span class="esp-option__desc">{{ item.desc }}</span>
                  <span v-if="item.recommended" class="esp-option__badge">推荐</span>
                  <span class="esp-option__check" aria-hidden="true"><i class="el-icon-check"></i></span>
                </button>
              </div>

              <div v-if="photoImportNamePreset === 'custom'" class="esp-custom">
                <p class="esp-custom__hint">勾选字段按「姓名 → 学生ID → 学号」用下划线拼接</p>
                <div class="esp-chips" role="group" aria-label="自由搭配字段">
                  <button
                    v-for="chip in photoNameCustomChipOptions"
                    :key="'imp-chip-' + chip.value"
                    type="button"
                    class="esp-chip"
                    :class="{ 'is-active': photoImportCustomParts.indexOf(chip.value) > -1 }"
                    :aria-pressed="photoImportCustomParts.indexOf(chip.value) > -1 ? 'true' : 'false'"
                    @click="togglePhotoImportCustomPart(chip.value)">
                    <span class="esp-chip__dot" aria-hidden="true"></span>
                    {{ chip.label }}
                  </button>
                </div>
              </div>

              <div class="esp-preview">
                <span class="esp-preview__icon" aria-hidden="true"><i class="el-icon-document"></i></span>
                <div class="esp-preview__meta">
                  <span class="esp-preview__label">预览示例</span>
                  <span
                    class="esp-preview__name"
                    :class="{ 'is-empty': !resolvedPhotoImportNameParts.length }">{{ photoImportNamePreview }}</span>
                </div>
              </div>
            </div>

            <div class="esp-import-layout__right">
              <div class="esp-import-upload">
                <p class="esp-section-label">ZIP 压缩包</p>
                <el-upload
                  drag
                  action="#"
                  accept=".zip,application/zip"
                  :auto-upload="false"
                  :limit="1"
                  :file-list="photoImportFileList"
                  :on-change="handlePhotoImportFileChange"
                  :on-remove="handlePhotoImportFileRemove">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将 ZIP 拖到此处，或<em>点击选择</em></div>
                  <div class="el-upload__tip" slot="tip">须为按班级文件夹组织的 .zip</div>
                </el-upload>
                <p class="esp-import-upload__hint">默认不覆盖已有头像；范围外班级文件夹将记为失败</p>
                <el-checkbox v-model="photoImportOverwrite" class="esp-import-upload__overwrite">
                  允许覆盖已有头像（慎用）
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="esp-footer">
          <el-button @click="photoImportDialogVisible = false">取消</el-button>
          <el-button type="primary" icon="el-icon-upload2" :loading="photoImportSubmitting" @click="confirmImportStudentPhotosZip">开始导入</el-button>
        </div>
      </el-dialog>

      <!-- 专属全屏居中照片导出进度弹窗（多阶段动态步进、呼吸动效、渐变进度条） -->
      <transition name="esp-fade">
        <div v-if="photoExportModalVisible" class="esp-progress-overlay" role="dialog" aria-modal="true">
          <div class="esp-progress-card" :class="`is-${photoExportStatus}`">
            <!-- 右上角关闭按钮（异常状态或导出完成后可直接关闭） -->
            <button
              v-if="photoExportStatus === 'error' || photoExportStatus === 'success'"
              type="button"
              class="esp-progress-close"
              aria-label="关闭"
              @click="closePhotoExportModal">
              <i class="el-icon-close"></i>
            </button>

            <!-- 呼吸发光高清相册图标 -->
            <div class="esp-progress-icon-wrap">
              <div class="esp-progress-pulse-glow" :class="`is-${photoExportStatus}`"></div>
              <div class="esp-progress-icon" :class="`is-${photoExportStatus}`">
                <i v-if="photoExportStatus === 'scanning'" class="el-icon-search"></i>
                <i v-else-if="photoExportStatus === 'zipping'" class="el-icon-folder-opened"></i>
                <i v-else-if="photoExportStatus === 'downloading'" class="el-icon-download"></i>
                <i v-else-if="photoExportStatus === 'success'" class="el-icon-check"></i>
                <i v-else-if="photoExportStatus === 'error'" class="el-icon-warning-outline"></i>
                <i v-else class="el-icon-picture-outline"></i>
              </div>
            </div>

            <!-- 标题与部门范围提示 -->
            <div class="esp-progress-header">
              <h3 class="esp-progress-title">
                {{ photoExportStatus === 'success' ? '照片导出完成' : photoExportStatus === 'error' ? '照片导出中断' : '全校学生照片打包导出' }}
              </h3>
              <p class="esp-progress-scope">
                当前范围：<em>{{ currentDepartmentName || '全校' }}</em>（含下级部门）
              </p>
            </div>

            <!-- 进度指示与彩色渐变进度条 -->
            <div class="esp-progress-meter">
              <div class="esp-progress-meta">
                <span class="esp-progress-stage-badge" :class="`is-${photoExportStatus}`">
                  {{ photoExportStageBadgeText }}
                </span>
                <span class="esp-progress-percent-val" :class="`is-${photoExportStatus}`">
                  {{ photoExportPercent }}%
                </span>
              </div>

              <div class="esp-progress-track">
                <div
                  class="esp-progress-bar"
                  :class="`is-${photoExportStatus}`"
                  :style="{ width: photoExportPercent + '%' }">
                  <span class="esp-progress-bar__shine"></span>
                </div>
              </div>
            </div>

            <!-- 动态阶段说明反馈 -->
            <div class="esp-progress-status-box">
              <p class="esp-progress-status-text" :class="{ 'is-error': photoExportStatus === 'error' }">
                <i v-if="photoExportStatus !== 'error' && photoExportStatus !== 'success'" class="el-icon-loading"></i>
                {{ photoExportStatusText }}
              </p>
              <p v-if="photoExportTransferDetail" class="esp-progress-transfer-detail">
                {{ photoExportTransferDetail }}
              </p>
            </div>

            <!-- 底部操作与辅助提示 -->
            <div class="esp-progress-footer">
              <template v-if="photoExportStatus === 'error'">
                <el-button size="medium" type="danger" plain icon="el-icon-circle-close" @click="closePhotoExportModal">
                  关闭查看错误
                </el-button>
              </template>
              <template v-else-if="photoExportStatus === 'success'">
                <span class="esp-progress-hint esp-success-hint">
                  <i class="el-icon-circle-check"></i> 文件已开始由浏览器接收，弹窗将在 1.5 秒后自动关闭…
                </span>
              </template>
              <template v-else>
                <span class="esp-progress-hint">
                  <i class="el-icon-info"></i> 服务端流式极速归档中，杜绝内存溢出，请勿关闭页面
                </span>
              </template>
            </div>
          </div>
        </div>
      </transition>

      <!-- 学生照片 ZIP 异步导入进度弹窗 -->
      <transition name="esp-fade">
        <div v-if="photoImportModalVisible" class="esp-progress-overlay" role="dialog" aria-modal="true">
          <div class="esp-progress-card" :class="`is-${photoImportUiStatus}`">
            <button
              v-if="photoImportUiStatus === 'error' || photoImportUiStatus === 'success'"
              type="button"
              class="esp-progress-close"
              aria-label="关闭"
              @click="closePhotoImportModal">
              <i class="el-icon-close"></i>
            </button>
            <div class="esp-progress-icon-wrap">
              <div class="esp-progress-pulse-glow" :class="`is-${photoImportUiStatus}`"></div>
              <div class="esp-progress-icon" :class="`is-${photoImportUiStatus}`">
                <i v-if="photoImportUiStatus === 'success'" class="el-icon-check"></i>
                <i v-else-if="photoImportUiStatus === 'error'" class="el-icon-warning-outline"></i>
                <i v-else class="el-icon-upload2"></i>
              </div>
            </div>
            <div class="esp-progress-header">
              <h3 class="esp-progress-title">
                {{ photoImportUiStatus === 'success' ? '照片导入完成' : photoImportUiStatus === 'error' ? '照片导入中断' : '学生照片 ZIP 异步导入' }}
              </h3>
              <p class="esp-progress-scope">
                当前范围：<em>{{ currentDepartmentName || '全校' }}</em>
              </p>
            </div>
            <div class="esp-progress-meter">
              <div class="esp-progress-meta">
                <span class="esp-progress-stage-badge" :class="`is-${photoImportUiStatus}`">
                  {{ photoImportStageText }}
                </span>
                <span class="esp-progress-percent-val" :class="`is-${photoImportUiStatus}`">
                  {{ photoImportPercent }}%
                </span>
              </div>
              <div class="esp-progress-track">
                <div
                  class="esp-progress-bar"
                  :class="`is-${photoImportUiStatus === 'running' ? 'zipping' : photoImportUiStatus}`"
                  :style="{ width: photoImportPercent + '%' }">
                  <span class="esp-progress-bar__shine"></span>
                </div>
              </div>
            </div>
            <div class="esp-progress-status-box">
              <p class="esp-progress-status-text" :class="{ 'is-error': photoImportUiStatus === 'error' }">
                <i v-if="photoImportUiStatus === 'running'" class="el-icon-loading"></i>
                {{ photoImportStatusMessage }}
              </p>
              <p v-if="photoImportProcessedDetail" class="esp-progress-transfer-detail">{{ photoImportProcessedDetail }}</p>
            </div>
            <div class="esp-progress-footer">
              <template v-if="photoImportUiStatus === 'error'">
                <el-button size="medium" type="danger" plain @click="closePhotoImportModal">关闭查看</el-button>
              </template>
              <template v-else-if="photoImportUiStatus === 'success'">
                <span class="esp-progress-hint esp-success-hint">
                  <i class="el-icon-circle-check"></i> 导入已完成，可查看明细
                </span>
              </template>
              <template v-else>
                <span class="esp-progress-hint">
                  <i class="el-icon-info"></i> 后台异步处理中，可关闭页面后稍后再查（同浏览器会话内可继续看进度）
                </span>
              </template>
            </div>
          </div>
        </div>
      </transition>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { getStudentInfoListPage, removeStudentInfo, editStudentInfo, addStudentInfo, exportStudentParentTemplate, importStudentParentBatch, bindCard, getUserCard, exportStudentInfo, exportStudentPhotosZip as requestStudentPhotosZipExport, submitImportStudentPhotosZip, getImportStudentPhotosZipStatus, importStudentCardList, batchDeleteStudent, getClassById, batchChangeStudentClass, getStudentLocalAvatarMigrateStatus, getDuplicateStudentWarnings, compareDuplicateStudentWithDingTalk, mergeDuplicateStudents } from '../../api/modules/personnel';
import { changeEnrollmentStatus } from '../../api/modules/studentEnrollment';
import { getTeachingDepartmentTree, getStudentLiveTypeList, syncDingDingUser, getDepartmentById } from '../../api/modules/department';
import { prepareDeptCascaderTree, deptIdsEqual, normalizeDeptId } from '../../utils/deptCascaderProps';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PasswordInput, { DEFAULT_LOGIN_PASSWORD } from '../../components/PasswordInput'
import LocalAvatarMigrateDialog from '../../components/LocalAvatarMigrateDialog'
import HeadPhotoCompressDialog from '../../components/HeadPhotoCompressDialog'
import StudentQrCodeDialog from '../../components/StudentQrCodeDialog'
import StudentParentManagement from './StudentParent/Management.vue'
import ImportResultDialog from '../../components/ImportResultDialog'
import { buildHeadPicFooFromDids, attachLocalAvatarFile, revokeLocalAvatarPreview, uploadHeadPic, stripOssPresignParams } from '../../utils/ossMediaUpload'
import { normalizeImportBatchResponse } from '../../utils/importResultParser'
import { fetchStudentLiveTypesByDeptId, applyLiveTypeFilterOptions } from '../../utils/studentLiveType'

// excel 读取
import { read, utils, writeFile } from 'xlsx'
import '../../style/person-import-dialog.css'
import '../../style/export-student-photos-dialog.css'

export default {
  components: { Toolbar, DepartmentPane, PasswordInput, LocalAvatarMigrateDialog, HeadPhotoCompressDialog, StudentQrCodeDialog, StudentParentManagement, ImportResultDialog },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '姓名',
          key: 'stuName',
          placeholder: '姓名',
        },
        {
          label: '学号',
          key: 'stuCode',
          placeholder: '学号',
        },
        {
          label: '卡号',
          key: 'cardNo',
          placeholder: '卡号',
        },
        {
          label: '监护人手机',
          key: 'parentPhone',
          placeholder: '手机号',
        },
        {
          label: '人员类型',
          key: 'liveTypeId',
          type: 'select',
          initValue: '',
          clearable: true,
          options: [
            { label: '全部', value: '' },
          ],
        },
        {
          label: '是否设置性别',
          key: 'sexSetStatus',
          type: 'select',
          initValue: '',
          clearable: true,
          options: [
            { label: '全部', value: '' },
            { label: '未设置', value: '0' },
            { label: '已设置', value: '1' },
          ],
        },
        {
          label: '照片状态',
          key: 'photoStatus',
          type: 'select',
          initValue: '',
          clearable: true,
          options: [
            { label: '全部状态', value: '' },
            { label: '无头像', value: '0' },
            { label: '已有头像', value: '1' },
          ],
        },
        {
          label: '是否绑卡',
          key: 'cardBindStatus',
          type: 'select',
          initValue: '',
          clearable: true,
          options: [
            { label: '全部', value: '' },
            { label: '未绑卡', value: '0' },
            { label: '已绑卡', value: '1' },
          ],
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      page: 1,
      /** 列表每页条数。创建于 2026-09-06 */
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      studentEditTab: 'basic',
      studentAddTab: 'basic',
      editFormRules: {
        StuName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        Password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        Dids: [
          { required: true, message: '请选择所属部门', trigger: 'change' }
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        StuName: "",
        Birthday: "",
        StuNational: "",
        Sex: 1,
        HomeTown: "",
        Dids: [],
        DepartmentId: 0,
        IdCard: "",
        SeatNumber: "",
        Height: "",
        Weight: "",
        CardNumber: "",
        Imei: "",
        BloodType: "",
        LiveTypeId: "",
        Account: "",
        Password: "",
        ContactPerson: "",
        ContactPhone: "",
        Address: "",
        domains: [],
        StuPolitical: "",
        StuCode: "",
        ThirdPartyCode: "",
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addPwdInputKey: 0,
      addLoading: false,
      addFormRules: {
        StuName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        Password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        Dids: [
          { required: true, message: '请选择所属部门', trigger: 'change' }
        ],
      },
      //新增界面数据
      addForm: {
        StuName: "",
        Birthday: "",
        StuNational: "",
        Sex: 1,
        HomeTown: "",
        Dids: [],
        DepartmentId: 0,
        IdCard: "",
        SeatNumber: "",
        Height: "",
        Weight: "",
        CardNumber: "",
        Imei: "",
        BloodType: "",
        LiveTypeId: "",
        Account: "",
        Password: DEFAULT_LOGIN_PASSWORD,
        ContactPerson: "",
        ContactPhone: "",
        Address: "",
        StuPolitical: "",
        StuCode: "",
        ThirdPartyCode: "",
      },
      DepartmentId: 0,
      SchoolId: 0, // 新增：保存当前部门所属学校的ID
      currentSchId: '',
      enrollmentTargetStatus: 1,
      enrollmentReason: '',
      enrollmentSaving: false,
      //监护人
      guardianVisible: false,
      currentUserId: '',
      currentStudentName: '',
      imageUrl: '',
      pendingAvatarFile: null,
      savedHeadPhotoImage: '',
      imageLoadding: false,
      imageSizeKb: 0,
      currentDepartment: null,
      totalCount: 0,
      noAvatarCount: 0,
      /** 当前范围未绑卡人数。创建于 2026-09-15 */
      noCardCount: 0,
      /** 当前范围未设置性别人数。创建于 2026-10-15 */
      noSexCount: 0,
      currentDepartmentName: '',
      /** 当前顶部学校的机构类型，用于控制钉钉同步按钮。最后更新：2026-08-30 */
      currentSchoolSchType: '',

      //excel
      outputs: [],
      excelShow: false,
      studentImportDialogVisible: false,
      studentImportFileRaw: null,
      studentImportParsing: false,
      studentImportUploadKey: 0,
      studentImportKeepFileOnClose: false,
      studentImportResultDialogVisible: false,
      importResult: null,
      // 导入监护人
      parentOutputs: [],
      parentExcelShow: false,
      parentImportDialogVisible: false,
      parentImportFileRaw: null,
      parentImportParsing: false,
      parentImportUploadKey: 0,
      parentImportKeepFileOnClose: false,
      exportLoading: false, // 导出加载状态（由 mixin / 模板下载按钮共用，不再渲染自定义全屏遮罩）
      localAvatarMigrateVisible: false,
      headPhotoCompressVisible: false,
      studentQrCodeDialogVisible: false,
      /** 重复学生检测。创建于 2026-09-03 */
      duplicateDialogVisible: false,
      duplicateLoading: false,
      duplicateGroups: [],
      duplicateActiveGroups: [],
      duplicateKeyword: '',
      /** 是否仅检测左侧所选部门节点（班级/年级等）；关=全校。创建于 2026-09-15 */
      duplicateScopeByDepartment: false,
      duplicatePage: 1,
      duplicatePageSize: 10,
      /** 防止清空/连续查询时旧请求回写结果。创建于 2026-09-03 */
      duplicateRequestSeq: 0,
      duplicateDingLoadingKey: '',
      duplicateMergeLoadingKey: '',
      duplicateSummary: {
        groupCount: 0,
        studentCount: 0
      },
      ossAvatarEnabled: false,
      // 专属全屏居中学生照片导出进度弹窗状态。最后更新：2026-09-08
      photoExportModalVisible: false,
      photoExportStatus: "scanning", // scanning (0~35%) | zipping (35~78%) | downloading (78~99%) | success (100%) | error
      photoExportPercent: 0,
      photoExportErrorMsg: "",
      photoExportTransferDetail: "",
      photoExportTimer: null,
      photoExportCloseTimeout: null,
      photoNameDialogVisible: false, // 导出学生照片命名规则弹窗
      photoNamePreset: "StuName_Id", // 快捷命名预设，custom 为自由搭配
      photoNameCustomParts: ["StuName", "Id"], // 自由搭配勾选字段
      photoNameCustomChipOptions: [
        { value: "StuName", label: "学生姓名" },
        { value: "Id", label: "学生ID" },
        { value: "StuCode", label: "学号" },
      ],
      photoNamePresetOptions: [
        { value: "StuName", label: "学生姓名", desc: "仅按姓名命名" },
        { value: "StuName_Id", label: "姓名 + 学生ID", desc: "避免重名覆盖", recommended: true },
        { value: "StuName_StuCode", label: "姓名 + 学号", desc: "适合学号齐全场景" },
        { value: "Id", label: "学生ID", desc: "唯一且简洁" },
        { value: "StuCode", label: "学号", desc: "仅按学号命名" },
        { value: "custom", label: "自由搭配", desc: "自行组合字段" },
      ],
      // 学生照片 ZIP 异步导入。最后更新：2026-09-08
      photoImportDialogVisible: false,
      photoImportModalVisible: false,
      photoImportSubmitting: false,
      photoImportJobId: "",
      photoImportPollTimer: null,
      photoImportCloseTimeout: null,
      photoImportFileList: [],
      photoImportFileRaw: null,
      photoImportOverwrite: false,
      photoImportNamePreset: "StuName_Id",
      photoImportCustomParts: ["StuName", "Id"],
      photoImportPercent: 0,
      photoImportServerStatus: "",
      photoImportServerStage: "",
      photoImportServerMessage: "",
      photoImportTotalFiles: 0,
      photoImportProcessedFiles: 0,
      photoImportSuccessCount: 0,
      photoImportFailCount: 0,
      photoImportErrorMsg: "",
      photoImportResultDialogVisible: false,
      photoImportResult: null,
      multipleSelection: [],
      bigType: 1, // 部门大类：0内部通讯录，1家校通讯录
      batchChangeClassDialogVisible: false,
      batchChangeClassLoading: false,
      classQueryLoading: false,
      batchChangeClassForm: {
        identifierType: "StudentId",
        studentIdsText: "",
        targetClassId: "",
        targetClassName: "",
      },
      batchClassOptions: [],
      batchClassSchoolId: 0,
      batchChangeClassResult: null,
      batchChangeFailedDialogVisible: false,
      batchChangeFailedItems: [],
      batchChangeFailedKeyword: "",
      batchChangeFailedPage: 1,
      batchChangeFailedPageSize: 10,
    };
  },
  computed: {
    /** 照片导出当前阶段徽章文案。最后更新：2026-09-08 */
    photoExportStageBadgeText() {
      switch (this.photoExportStatus) {
        case "scanning":
          return "1. 路径校验";
        case "zipping":
          return "2. 极速归档";
        case "downloading":
          return "3. 数据传输";
        case "success":
          return "4. 导出就绪";
        case "error":
          return "异常中断";
        default:
          return "准备中";
      }
    },
    /** 照片导出当前状态主文案。最后更新：2026-09-08 */
    photoExportStatusText() {
      if (this.photoExportStatus === "error") {
        return this.photoExportErrorMsg || "导出过程中遇到错误，未生成压缩包。";
      }
      if (this.photoExportStatus === "success") {
        return "打包完成！浏览器正在保存文件...";
      }
      if (this.photoExportStatus === "downloading") {
        return "正在传输并接收照片压缩包文件...";
      }
      if (this.photoExportStatus === "zipping") {
        return "正在进行流式极速归档打包 (ZIP 压缩)...";
      }
      return "正在扫描并校验服务器磁盘中的高清照片...";
    },
    /** 当前生效的照片命名字段（有序） */
    resolvedPhotoNameParts() {
      if (this.photoNamePreset === "custom") {
        const order = ["StuName", "Id", "StuCode"];
        const selected = this.photoNameCustomParts || [];
        return order.filter(key => selected.indexOf(key) > -1);
      }
      return String(this.photoNamePreset || "StuName_Id")
        .split("_")
        .filter(Boolean);
    },
    /** 命名规则预览示例 */
    photoNamePreview() {
      const sample = { StuName: "张三", Id: "10001", StuCode: "2024001" };
      const parts = this.resolvedPhotoNameParts;
      if (!parts.length) {
        return "（请至少选择一个字段）";
      }
      return parts.map(key => sample[key] || key).join("_") + ".jpg";
    },
    /** 导入命名规则（有序字段） */
    resolvedPhotoImportNameParts() {
      if (this.photoImportNamePreset === "custom") {
        const order = ["StuName", "Id", "StuCode"];
        const selected = this.photoImportCustomParts || [];
        return order.filter(key => selected.indexOf(key) > -1);
      }
      return String(this.photoImportNamePreset || "StuName_Id")
        .split("_")
        .filter(Boolean);
    },
    /** 导入命名规则预览 */
    photoImportNamePreview() {
      const sample = { StuName: "张三", Id: "10001", StuCode: "2024001" };
      const parts = this.resolvedPhotoImportNameParts;
      if (!parts.length) {
        return "（请至少选择一个字段）";
      }
      return parts.map(key => sample[key] || key).join("_") + ".jpg";
    },
    /** 导入进度 UI 状态：running | success | error */
    photoImportUiStatus() {
      const s = String(this.photoImportServerStatus || "").toLowerCase();
      if (s === "completed") return "success";
      if (s === "failed") return "error";
      return "running";
    },
    /** 导入进度阶段徽章 */
    photoImportStageText() {
      if (this.photoImportUiStatus === "success") return "导入完成";
      if (this.photoImportUiStatus === "error") return "异常中断";
      const stage = String(this.photoImportServerStage || "").toLowerCase();
      if (stage === "extracting") return "1. 解压扫描";
      if (stage === "importing") return "2. 匹配上传";
      return "准备中";
    },
    /** 导入进度主文案 */
    photoImportStatusMessage() {
      if (this.photoImportUiStatus === "error") {
        return this.photoImportErrorMsg || "导入任务失败，请查看错误说明。";
      }
      if (this.photoImportUiStatus === "success") {
        return this.photoImportServerMessage || "全部照片已处理完毕。";
      }
      return this.photoImportServerMessage || "正在后台异步处理 ZIP 中的照片…";
    },
    /** 导入已处理数量明细 */
    photoImportProcessedDetail() {
      if (!this.photoImportTotalFiles) return "";
      return `已处理 ${this.photoImportProcessedFiles} / ${this.photoImportTotalFiles} 张，成功 ${this.photoImportSuccessCount}，失败 ${this.photoImportFailCount}`;
    },
    batchChangeFailedFilteredItems() {
      const keyword = (this.batchChangeFailedKeyword || "").trim().toLowerCase();
      if (!keyword) {
        return this.batchChangeFailedItems || [];
      }
      return (this.batchChangeFailedItems || []).filter(item => {
        const text = [
          item.InputValue,
          item.StudentId,
          item.StuCode,
          item.StudentName,
          item.Message
        ].join(" ").toLowerCase();
        return text.indexOf(keyword) > -1;
      });
    },
    batchChangeFailedPagedItems() {
      const list = this.batchChangeFailedFilteredItems || [];
      const page = this.batchChangeFailedPage > 0 ? this.batchChangeFailedPage : 1;
      const start = (page - 1) * this.batchChangeFailedPageSize;
      return list.slice(start, start + this.batchChangeFailedPageSize);
    },
    /** 仅钉钉学校显示同步钉钉入口。最后更新：2026-08-30 */
    isDingTalkSchool() {
      return String(this.currentSchoolSchType || '').toLowerCase() === 'dingding'
    },
  },
  methods: {
    /** 是否为「同步钉钉*」入口（不匹配头像迁移等其它按钮）。最后更新：2026-08-30 */
    isDingTalkSyncToolbarButton(btn) {
      if (!btn) return false
      const name = String(btn.name || '')
      const func = String(btn.Func || '').toLowerCase()
      // 名称含「钉钉」最稳妥；Func 仅精确匹配权限里的 syncUser
      if (/钉钉/.test(name)) return true
      return func === 'syncuser'
    },
    /** 按学校类型隐藏「同步钉钉人员」等钉钉专用入口；重复检测全校可用（无钉钉时按姓名）。最后更新：2026-09-15 */
    refreshDingTalkSyncButtonVisibility() {
      const hide = !this.isDingTalkSchool
      ;(this.buttonList || []).forEach(btn => {
        const func = String(btn.Func || '').toLowerCase()
        // 重复学生检测：钉钉/非钉钉均可（非钉钉走同名检测）
        if (func === 'duplicatestudentcheck') {
          this.$set(btn, 'IsHide', false)
          return
        }
        if (!this.isDingTalkSyncToolbarButton(btn)) return
        // 排除头像迁移 / 压缩等非钉钉工具
        if (/migrate|compress|qrcode/.test(func)) return
        this.$set(btn, 'IsHide', hide)
      })
      // 钉钉显隐改完后，立刻按 OSS 开关还原迁移按钮，避免异步竞态互相覆盖
      this.updateMigrateButtonVisibility()
    },
    /** 加载当前顶部学校的 SchType。最后更新：2026-08-30 */
    async loadCurrentSchoolSchType() {
      const schoolId = this.resolveActiveSchoolId()
      if (!schoolId) {
        this.currentSchoolSchType = ''
        this.refreshDingTalkSyncButtonVisibility()
        return
      }
      try {
        const res = await getDepartmentById(schoolId)
        const dept = (res.data && res.data.response) || {}
        this.currentSchoolSchType = dept.SchType || dept.schType || ''
      } catch (e) {
        this.currentSchoolSchType = ''
      }
      this.refreshDingTalkSyncButtonVisibility()
    },
    /** 获取顶部选择的学校 ID，禁止回退到年级或班级部门。 */
    resolveActiveSchoolId() {
      const candidates = [
        this.$store.state.activeSchoolId,
        window.localStorage.getItem('activeSchoolId'),
        this.SchoolId,
      ];
      return candidates.find(id => /^\d+$/.test(String(id || '')) && String(id) !== '0') || '';
    },
    /** 校验失败时切换到含错误字段的 Tab。最后更新：2026-06-28 */
    focusFormTabOnValidateFail(formRef, tabField, accountFieldProps) {
      this.$nextTick(() => {
        const form = this.$refs[formRef];
        if (!form || !form.fields) return;
        const accountSet = new Set(accountFieldProps || []);
        for (let i = 0; i < form.fields.length; i++) {
          const field = form.fields[i];
          if (field.validateState !== 'error') continue;
          const prop = field.prop;
          const isAccount = accountSet.has(prop) || (prop && String(prop).indexOf('domains.') === 0);
          this[tabField] = isAccount ? 'account' : 'basic';
          break;
        }
      });
    },
    studentAccountFieldProps() {
      return ['CardNumber', 'StuPolitical', 'BloodType', 'LiveTypeId', 'Account', 'Password', 'ContactPerson', 'ContactPhone', 'ThirdPartyCode'];
    },
    /**
     * 部门级联 options 统一清洗（去空 children、放开可展开上级）。创建于 2026-08-26
     */
    setPersonDeptCascaderOptions(rawNodes) {
      const prepared = prepareDeptCascaderTree(rawNodes);
      this.options = prepared;
      return prepared;
    },

    /**
     * 判断节点是否为班级（人员归属只能落在班级）。创建于 2026-08-26
     */
    isPersonClassDeptNode(node) {
      if (!node) return false;
      const orgType = String(node.DeptOrgType || node.deptOrgType || '').toLowerCase();
      if (orgType === 'class') return true;
      const children = node.children || [];
      return node.BigType == 1 && children.length === 0;
    },

    /**
     * 在 options 中按 Id 查找节点。创建于 2026-08-26
     */
    findPersonDeptNodeById(nodes, deptId) {
      const list = Array.isArray(nodes) ? nodes : [];
      for (let i = 0; i < list.length; i++) {
        const node = list[i];
        if (!node) continue;
        if (String(node.value) === String(deptId)) return node;
        const found = this.findPersonDeptNodeById(node.children || [], deptId);
        if (found) return found;
      }
      return null;
    },

    /**
     * 按部门 Id 在当前 options 中回填级联路径；仅班级叶子可预填。最后更新：2026-08-26
     */
    fillPersonDeptPath(formKey, deptId, options) {
      const roots = this.options || [];
      if (!roots.length || !deptId) return;
      const opts = options || {};
      const requireClass = !!opts.requireClass;
      if (requireClass) {
        const target = this.findPersonDeptNodeById(roots, deptId);
        if (!this.isPersonClassDeptNode(target)) return;
      }
      for (let i = 0; i < roots.length; i++) {
        const path = this.findPathByDeptId(roots[i], deptId, []);
        if (path && path.length) {
          this.$set(this[formKey], 'Dids', path);
          return;
        }
      }
    },

    // 递归寻找当前学校 ID 的部门树节点
    findSchoolNode(node, schoolId) {
      if (!node) return null;
      if (deptIdsEqual(node.value, schoolId)) {
        return node;
      }
      if (node.children && node.children.length) {
        for (let i = 0; i < node.children.length; i++) {
          const found = this.findSchoolNode(node.children[i], schoolId);
          if (found) return found;
        }
      }
      return null;
    },
    // 根据 DepartmentId 在树中递归搜索完整路径，路径值直接来自树节点（类型与 options 完全一致）
    findPathByDeptId(node, deptId, path) {
      const currentPath = [...path, node.value];
      if (String(node.value) === String(deptId)) {
        return currentPath;
      }
      if (node.children && node.children.length) {
        for (let i = 0; i < node.children.length; i++) {
          const found = this.findPathByDeptId(node.children[i], deptId, currentPath);
          if (found) return found;
        }
      }
      return null;
    },
    // 新增：格式化用户类型显示
    formatStuPolitical(row, column, cellValue) {
      if (cellValue === '1') {
        return '专用';
      } else if (cellValue === '' || cellValue === null) {
        return '普通';
      }
      return cellValue;
    },
    formatSex(row, column, cellValue) {
      if (cellValue === 1 || cellValue === '1') return '男';
      if (cellValue === 0 || cellValue === '0') return '女';
      return '';
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleRowClick(row) {
      if (!this.$refs.table) return;
      this.$refs.table.toggleRowSelection(row);
    },

    submitForm(data) {

      if (!data.value) {
        this.$message({
          message: "请输入卡号。",
          type: "error",
        });
        return;
      }

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请先选择一行数据！',
          type: 'error',
        })
        return
      }

      var row = rows[0];
      var bindForm = { "UserId": row.Id, "CardId": data.value, "IsBind": 1 }
      this.addLoading = true;
      bindCard(bindForm).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });

          let para = {
            userId: row.Id,
          };

          getUserCard(para).then((res) => {
            this.editForm.domains = res.data.response
          });

        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.addLoading = false;
      });
    },

    delDomain(item) {
      var index = this.editForm.domains.indexOf(item)
      if (index !== -1) {
        this.editForm.domains.splice(index, 1)
      }
    },

    removeDomain(item) {
      if (!item.value) {
        this.$message({
          message: "请输入卡号。",
          type: "error",
        });
        return;
      }

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请先选择一行数据！',
          type: 'error',
        })
        return
      }

      var row = rows[0];
      var bindForm = { "UserId": row.Id, "CardId": item.value, "IsBind": 0 }

      this.addLoading = true;
      bindCard(bindForm).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });

          let para = {
            userId: row.Id,
          };

          getUserCard(para).then((res) => {
            this.editForm.domains = res.data.response
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.addLoading = false;
      });

    },
    addDomain() {
      console.log(this.editForm);
      this.editForm.domains.push({
        value: '',
        key: Date.now(),
        type: 0
      });
    },
    revokePendingAvatarLocal() {
      revokeLocalAvatarPreview(this.imageUrl);
      this.pendingAvatarFile = null;
    },
    resetAvatarState() {
      this.revokePendingAvatarLocal();
      this.imageUrl = '';
      this.imageSizeKb = 0;
      this.savedHeadPhotoImage = '';
    },
    /** 选择头像：仅本地预览，点击保存时再上传 OSS/本机。最后更新：2026-06-29 */
    handleAvatarChange(file) {
      if (!file || !file.raw) return;
      const raw = file.raw;
      const allowType = ['image/jpg', 'image/png', 'image/jpeg'];
      if (allowType.indexOf(raw.type) < 0) {
        this.$message.error('图片格式错误，请上传 jpg/png');
        return;
      }
      this.revokePendingAvatarLocal();
      const local = attachLocalAvatarFile(raw);
      this.pendingAvatarFile = local.pendingAvatarFile;
      this.imageUrl = local.pendingAvatarPreviewUrl;
      this.imageSizeKb = Number((raw.size / 1024).toFixed(1));
    },
    /** 保存前上传待提交头像，返回最终入库路径。 */
    async ensureHeadPhotoUploaded(dids) {
      if (this.pendingAvatarFile) {
        const foo = buildHeadPicFooFromDids(dids || []);
        const { url, sizeKb } = await uploadHeadPic(this.pendingAvatarFile, this, foo);
        if (sizeKb && !Number.isNaN(Number(sizeKb)) && Number(sizeKb) > 0) {
          this.imageSizeKb = Number(Number(sizeKb).toFixed(1));
        }
        this.revokePendingAvatarLocal();
        this.imageUrl = url;
        this.savedHeadPhotoImage = url;
        return url;
      }
      if (!this.imageUrl) return '';
      if (String(this.imageUrl).indexOf('blob:') === 0) return '';
      return stripOssPresignParams(this.savedHeadPhotoImage || this.imageUrl);
    },
    async calcImageSizeKbByUrl(imagePath) {
      if (!imagePath) return 0;
      const imageUrl = this.$resolveImageSrc(imagePath);
      try {
        const headResp = await fetch(imageUrl, { method: "HEAD", cache: "no-store" });
        const len = Number(headResp.headers.get("content-length"));
        if (!Number.isNaN(len) && len > 0) {
          return Number((len / 1024).toFixed(1));
        }
      } catch (e) {
      }

      try {
        const getResp = await fetch(imageUrl, { cache: "no-store" });
        const blob = await getResp.blob();
        if (blob && blob.size > 0) {
          return Number((blob.size / 1024).toFixed(1));
        }
      } catch (e) {
      }

      return 0;
    },
    async fillImageSizeForEditRow(row) {
      if (!row || !row.HeadPhotoImage) {
        this.imageSizeKb = 0;
        return;
      }

      const sizeFromList = Number(
        row.HeadPhotoSizeKb || row.HeadPhotoSize || row.HeadPhotoKb || row.ImageSizeKb || 0
      );
      if (!Number.isNaN(sizeFromList) && sizeFromList > 0) {
        this.imageSizeKb = sizeFromList;
        return;
      }

      this.imageSizeKb = await this.calcImageSizeKbByUrl(row.HeadPhotoImage);
    },

    //显示监护人列表
    ShowStudentParent(row) {
      this.currentUserId = row.Id;
      this.currentStudentName = row.StuName || '';
      this.guardianVisible = true;
    },
    /** 从重复检测打开该学生的监护人管理。创建于 2026-09-03 */
    showDuplicateStudentParent(row) {
      if (!row || !row.StudentId) return
      this.ShowStudentParent({
        Id: row.StudentId,
        StuName: row.StuName || ''
      })
    },

    // 编辑弹窗「学籍异动」Tab：办理休学/转学/退学
    submitEnrollmentChange() {
      if (!this.editForm || !this.editForm.Id) {
        this.$message.warning('请先打开学生编辑');
        return;
      }
      if (![1, 2, 3].includes(this.enrollmentTargetStatus)) {
        this.$message.warning('请选择异动类型');
        return;
      }
      if (!this.enrollmentReason || !String(this.enrollmentReason).trim()) {
        this.$message.warning('请填写办理原因');
        return;
      }
      const schId = this.currentSchId || this.editForm.SchId;
      if (!schId) {
        this.$message.warning('无法识别学校 SchId，请先在左侧选中学校节点下的班级');
        return;
      }
      const actionMap = { 1: '休学', 2: '转学', 3: '退学' };
      const actionName = actionMap[this.enrollmentTargetStatus] || '学籍异动';
      this.$confirm(`确认对「${this.editForm.StuName}」办理${actionName}？办理后将离开在读花名册。`, '提示', {
        type: 'warning'
      }).then(() => {
        this.doEnrollmentChange(schId, false);
      }).catch(() => {});
    },

    /**
     * 提交学籍异动；转学/退学被余额拦截时，提示用户确认后带 ConfirmBalance 重试。最后更新：2026-10-10
     */
    doEnrollmentChange(schId, confirmBalance) {
      this.enrollmentSaving = true;
      changeEnrollmentStatus({
        SchId: schId,
        StudentIds: [this.editForm.Id],
        TargetStatus: this.enrollmentTargetStatus,
        Reason: String(this.enrollmentReason).trim(),
        ConfirmBalance: confirmBalance
      }).then(res => {
        this.enrollmentSaving = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '办理成功');
          this.editFormVisible = false;
          this.enrollmentReason = '';
          this.enrollmentTargetStatus = 1;
          this.handleQuery();
          return;
        }
        const msg = (res.data && res.data.msg) || '办理失败';
        if (!confirmBalance && msg.indexOf('账户仍有余额') >= 0) {
          this.$confirm(msg, '学生账户仍有余额', {
            confirmButtonText: '已知晓，余额另行处理并继续',
            cancelButtonText: '返回先去退费',
            type: 'warning'
          }).then(() => {
            this.doEnrollmentChange(schId, true);
          }).catch(() => {});
          return;
        }
        this.$message.error(msg);
      }).catch(() => {
        this.enrollmentSaving = false;
      });
    },

    handleChange(value) {
      const currentLiveTypeId = this.liveTypeId;
      this.liveTypeList = [];
      var id = "";
      if (value.length > 1) {
        id = value[value.length - 1];
      } else {
        id = value[0];
      }
      let para = {
        id: id,
      };
      getStudentLiveTypeList(para).then((res) => {
        this.liveTypeList = res.data.response || [];
        // 切换所属部门后：若原人员类型仍在新列表中，则自动保留；否则清空
        const hasCurrentLiveType = this.liveTypeList.some(item => String(item.LiveTypeId) === String(currentLiveTypeId));
        this.liveTypeId = hasCurrentLiveType ? currentLiveTypeId : "";
      });
    },

    /**
     * 按左侧部门加载人员类型筛选项（本校命名）。最后更新：2026-09-16
     */
    async loadLiveTypeFilter(departmentId) {
      const currentLiveTypeId = this.$refs.toolbar
        ? this.$refs.toolbar.searchObj.liveTypeId
        : (this.filters && this.filters.liveTypeId);
      const types = await fetchStudentLiveTypesByDeptId(departmentId);
      applyLiveTypeFilterOptions(this.searchList, types);
      const valid = !currentLiveTypeId || types.some((t) => String(t.LiveTypeId) === String(currentLiveTypeId));
      const nextVal = valid ? (currentLiveTypeId || '') : '';
      if (this.$refs.toolbar) {
        this.$set(this.$refs.toolbar.searchObj, 'liveTypeId', nextVal);
      }
      if (this.filters && this.filters.liveTypeId && !valid) {
        this.filters = { ...this.filters, liveTypeId: '' };
      }
    },
    async treeNodeClick(data, node, component) {
      this.currentDepartmentName = data.label || data.name || ''
      this.currentDepartment = data;
      this.DepartmentId = data.value
      
      // 向上寻找当前节点所属的学校ID（优先 DeptOrgType=school，避免误取校区）。最后更新：2026-08-26
      let schoolId = 0;
      let schoolSchId = (data && data.SchId) || '';
      let tempNode = node;
      while (tempNode) {
        const deptOrgType = String((tempNode.data && (tempNode.data.DeptOrgType || tempNode.data.deptOrgType)) || "").toLowerCase();
        if (tempNode.data && deptOrgType === "school") {
          schoolId = tempNode.data.value;
          schoolSchId = tempNode.data.SchId || schoolSchId;
          this.currentSchoolSchType = tempNode.data.SchType || tempNode.data.schType || this.currentSchoolSchType;
          break;
        }
        if (!schoolSchId && tempNode.data && tempNode.data.SchId) {
          schoolSchId = tempNode.data.SchId;
        }
        tempNode = tempNode.parent;
      }
      // 未标 school 时，回退为树中最接近根的部门节点
      if (!schoolId) {
        tempNode = node;
        while (tempNode && tempNode.parent && tempNode.parent.level > 0) {
          tempNode = tempNode.parent;
        }
        if (tempNode && tempNode.data) {
          schoolId = tempNode.data.value;
          schoolSchId = tempNode.data.SchId || schoolSchId;
        }
      }
      this.SchoolId = schoolId || data.value;
      this.currentSchId = schoolSchId || this.currentSchId || '';
      this.refreshDingTalkSyncButtonVisibility();

      this.page = 1;
      this.bigType = 1;
      if (this.batchChangeClassDialogVisible) {
        if (this.batchChangeClassForm.targetClassId) {
          this.batchChangeClassForm.targetClassId = "";
          this.batchChangeClassForm.targetClassName = "";
          this.$message.warning("已切换左侧部门，目标班级已清空，请重新选择");
        }
        this.loadBatchClassOptions();
      }
      await this.loadLiveTypeFilter(this.DepartmentId);
      this.handleQuery();
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    /** 切换每页条数。创建于 2026-09-06 */
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        intPageSize: this.pageSize,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;

      //NProgress.start();
      getStudentInfoListPage(para).then(async (res) => {
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        await this.prefetchListOssMedia(rows, 'HeadPhotoImage');
        this.users = rows;
        this.listLoading = false;
        this.totalCount = res.data.response.dataCount || 0;
        if (res.data.response && res.data.response.noAvatarCount !== undefined && res.data.response.noAvatarCount !== null) {
          this.noAvatarCount = res.data.response.noAvatarCount;
        }
        if (res.data.response && res.data.response.noCardCount !== undefined && res.data.response.noCardCount !== null) {
          this.noCardCount = res.data.response.noCardCount;
        }
        if (res.data.response && res.data.response.noSexCount !== undefined && res.data.response.noSexCount !== null) {
          this.noSexCount = res.data.response.noSexCount;
        }
        //NProgress.done();
      });
    },
    /**
     * 点击「无头像人数: N」胶囊标签，自动切换照片状态为无头像并触发查询。最后更新：2026-09-08
     */
    handleQuickFilterNoAvatar() {
      const isFilteringNoAvatar = this.filters && this.filters.photoStatus === '0';
      const targetVal = isFilteringNoAvatar ? '' : '0';
      if (this.$refs.toolbar) {
        this.$set(this.$refs.toolbar.searchObj, 'photoStatus', targetVal);
        this.$refs.toolbar.triggerQueryByEnter();
      } else {
        this.filters = {
          ...this.filters,
          photoStatus: targetVal,
        };
        this.page = 1;
        this.handleQuery();
      }
    },
    /**
     * 点击「未绑卡人数: N」胶囊标签，自动切换绑卡状态为未绑卡并触发查询。创建于 2026-09-15
     */
    handleQuickFilterNoCard() {
      const isFilteringNoCard = this.filters && this.filters.cardBindStatus === '0';
      const targetVal = isFilteringNoCard ? '' : '0';
      if (this.$refs.toolbar) {
        this.$set(this.$refs.toolbar.searchObj, 'cardBindStatus', targetVal);
        this.$refs.toolbar.triggerQueryByEnter();
      } else {
        this.filters = {
          ...this.filters,
          cardBindStatus: targetVal,
        };
        this.page = 1;
        this.handleQuery();
      }
    },
    /**
     * 点击「无设置性别人数」胶囊，切换是否设置性别为未设置并查询。创建于 2026-10-15
     */
    handleQuickFilterNoSex() {
      const isFilteringNoSex = this.filters && this.filters.sexSetStatus === '0';
      const targetVal = isFilteringNoSex ? '' : '0';
      if (this.$refs.toolbar) {
        this.$set(this.$refs.toolbar.searchObj, 'sexSetStatus', targetVal);
        this.$refs.toolbar.triggerQueryByEnter();
      } else {
        this.filters = {
          ...this.filters,
          sexSetStatus: targetVal,
        };
        this.page = 1;
        this.handleQuery();
      }
    },
    //删除
    handleDel() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择要删除的一行数据！',
          type: 'error',
        })
        return
      }

      var row = rows[0];

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeStudentInfo(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },

    // 批量删除
    handleDelUsers() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要删除的人员！');
        return;
      }
      const ids = this.multipleSelection.map(item => item.Id).join(',');
      this.$confirm('确认要批量删除选中的人员吗？', '提示', { type: 'warning' })
        .then(() => {
          this.listLoading = true;
          batchDeleteStudent({ ids: ids }).then(res => {
            this.listLoading = false;
            if (res.data.success) {
              this.$message.success(res.data.msg || '批量删除成功');
              this.handleQuery();
            } else {
              this.$message.error(res.data.msg || '批量删除失败');
            }
          }).catch(() => {
            this.listLoading = false;
          });
        });
    },

    openStudentQrCodeDialog() {
      this.studentQrCodeDialogVisible = true;
    },

    openBatchChangeClassDialog() {
      this.batchChangeClassDialogVisible = true;
      this.batchChangeClassLoading = false;
      this.classQueryLoading = false;
      this.batchChangeClassResult = null;
      this.batchChangeClassForm = {
        identifierType: "StudentId",
        studentIdsText: "",
        targetClassId: "",
        targetClassName: "",
      };
      this.loadBatchClassOptions();
    },
    loadBatchClassOptions() {
      const currentDepartmentId = normalizeDeptId(this.DepartmentId);
      if (!currentDepartmentId) {
        this.batchClassOptions = [];
        this.batchClassSchoolId = '';
        this.$message.error("请先在左侧选择当前学校下的部门");
        return;
      }
      // 固定学校范围加载班级树，避免弹出总平台/其他学校。最后更新：2026-10-18
      const schoolId = normalizeDeptId(this.SchoolId)
        || normalizeDeptId(this.$store.state.activeSchoolId)
        || normalizeDeptId(window.localStorage.getItem('activeSchoolId'))
        || currentDepartmentId;
      if (!schoolId) {
        this.batchClassOptions = [];
        this.batchClassSchoolId = '';
        this.$message.warning("请先选择学校");
        return;
      }
      getTeachingDepartmentTree({ pid: 0, scopeDepartmentId: schoolId }).then((res) => {
        const root = res && res.data && res.data.response;
        const options = [];
        let currentSchoolId = schoolId;
        const walk = (nodes, scopedSchoolId = '') => {
          (nodes || []).forEach((node) => {
            const children = node.children || [];
            const deptOrgType = (node.DeptOrgType || node.deptOrgType || "").toLowerCase();
            const nodeId = normalizeDeptId(node.value);
            const nextSchoolId = deptOrgType === "school" ? nodeId : scopedSchoolId;
            if (deptIdsEqual(nodeId, currentDepartmentId) && nextSchoolId) {
              currentSchoolId = nextSchoolId;
            }
            const isClassNode = deptOrgType === "class" || (node.BigType == 1 && children.length === 0);
            if (isClassNode && node.value && node.label && nextSchoolId) {
              options.push({
                id: normalizeDeptId(node.value),
                name: node.label,
                schoolId: nextSchoolId
              });
            }
            if (children.length) {
              walk(children, nextSchoolId);
            }
          });
        };
        walk(root ? [root] : [], schoolId);
        if (!currentSchoolId) {
          this.batchClassOptions = [];
          this.batchClassSchoolId = '';
          this.$message.warning("未识别当前学校，请重新选择左侧学校节点后重试");
          return;
        }
        this.batchClassOptions = options.filter(item => deptIdsEqual(item.schoolId, currentSchoolId));
        this.batchClassSchoolId = currentSchoolId;
      }).catch(() => {
        this.batchClassOptions = [];
        this.batchClassSchoolId = 0;
      });
    },
    handleBatchTargetClassSelect() {
      this.batchChangeClassForm.targetClassName = "";
      if (!this.batchChangeClassForm.targetClassId) {
        return;
      }
      this.queryBatchTargetClass();
    },
    parseBatchChangeIdentifiers() {
      const raw = this.batchChangeClassForm.studentIdsText || "";
      const parts = raw.split(/[\s,，;；]+/g).map(v => (v || "").trim()).filter(v => !!v);
      if (this.batchChangeClassForm.identifierType === "StuCode") {
        return Array.from(new Set(parts));
      }
      const numIds = parts.filter(v => /^\d+$/.test(v)).map(v => Number(v));
      return Array.from(new Set(numIds));
    },
    parseStuCodeItemsForBatchChange() {
      const raw = this.batchChangeClassForm.studentIdsText || "";
      const lines = raw.split(/\r?\n/g).map(v => (v || "").trim()).filter(v => !!v);
      const rows = [];
      lines.forEach((line) => {
        const cols = line.split(/[,\t，]+/g).map(v => (v || "").trim()).filter(v => !!v);
        if (cols.length >= 2) {
          rows.push({ stuCode: cols[0], studentName: cols[1] });
          return;
        }
        const bySpace = line.split(/\s+/g).map(v => (v || "").trim()).filter(v => !!v);
        if (bySpace.length >= 2) {
          rows.push({ stuCode: bySpace[0], studentName: bySpace[1] });
          return;
        }
        if (line) {
          rows.push({ stuCode: line, studentName: "" });
        }
      });
      const map = {};
      rows.forEach(item => {
        const key = `${item.stuCode}__${item.studentName || ""}`.toLowerCase();
        if (!map[key]) {
          map[key] = item;
        }
      });
      return Object.values(map).filter(item => !!item.stuCode);
    },
    queryBatchTargetClass() {
      const classId = normalizeDeptId(this.batchChangeClassForm.targetClassId);
      if (!classId) {
        this.$message.error("请输入有效的班级ID");
        return;
      }
      const currentDepartmentId = normalizeDeptId(this.DepartmentId);
      if (!currentDepartmentId) {
        this.$message.error("请先在左侧部门树选择一个部门");
        return;
      }
      this.classQueryLoading = true;
      getClassById({ departmentId: classId, currentDepartmentId: currentDepartmentId }).then((res) => {
        this.classQueryLoading = false;
        if (!res || !res.data || !res.data.success || !res.data.response) {
          this.batchChangeClassForm.targetClassName = "";
          this.$message.error((res && res.data && res.data.msg) || "班级不存在");
          return;
        }
        this.batchChangeClassForm.targetClassName = res.data.response.Name || "";
        this.$message.success("班级查询成功");
      }).catch(() => {
        this.classQueryLoading = false;
        this.batchChangeClassForm.targetClassName = "";
      });
    },
    submitBatchChangeClass() {
      const isStuCodeMode = this.batchChangeClassForm.identifierType === "StuCode";
      const stuCodeItems = isStuCodeMode ? this.parseStuCodeItemsForBatchChange() : [];
      const identifiers = isStuCodeMode ? stuCodeItems.map(i => i.stuCode) : this.parseBatchChangeIdentifiers();
      if (!identifiers.length) {
        this.$message.error(isStuCodeMode ? "请输入至少一个有效学号" : "请输入至少一个有效学生ID");
        return;
      }
      const classId = normalizeDeptId(this.batchChangeClassForm.targetClassId);
      if (!classId) {
        this.$message.error("请输入有效的班级ID");
        return;
      }
      if (!this.batchChangeClassForm.targetClassName) {
        this.$message.error("请先查询并确认班级信息");
        return;
      }
      this.$confirm(`确认将 ${identifiers.length} 位学生批量调整到【${this.batchChangeClassForm.targetClassName}】吗？`, "提示", { type: "warning" })
        .then(() => {
          this.batchChangeClassLoading = true;
          const submitData = {
            identifierType: this.batchChangeClassForm.identifierType,
            departmentId: classId,
          };
          if (isStuCodeMode) {
            submitData.stuCodes = identifiers;
            submitData.stuCodeItems = stuCodeItems;
          } else {
            submitData.studentIds = identifiers;
          }
          return batchChangeStudentClass({
            ...submitData
          });
        })
        .then((res) => {
          this.batchChangeClassLoading = false;
          const response = (res && res.data && res.data.response) || {};
          this.batchChangeClassResult = response;
          if (res && res.data && res.data.success) {
            this.$message.success(res.data.msg || `批量改班完成：成功${response.SuccessCount || 0}条，失败${response.FailCount || 0}条`);
            if ((response.FailCount || 0) > 0) {
              this.openBatchChangeFailedDialog();
            }
          } else {
            this.$message.error((res && res.data && res.data.msg) || "批量改班失败");
          }
          this.handleQuery();
        })
        .catch(() => {
          this.batchChangeClassLoading = false;
        });
    },
    openBatchChangeFailedDialog() {
      const result = this.batchChangeClassResult;
      if (!result || !result.Items || !result.Items.length) {
        this.$message.warning("暂无失败明细");
        return;
      }
      const failed = result.Items.filter(i => !i.IsSuccess);
      if (!failed.length) {
        this.$message.success("没有失败记录");
        return;
      }
      this.batchChangeFailedItems = failed.map(i => ({
        InputValue: i.InputValue || "-",
        StudentId: i.StudentId || "-",
        StuCode: i.StuCode || "-",
        StudentName: i.StudentName || "-",
        Message: i.Message || "未知"
      }));
      this.batchChangeFailedKeyword = "";
      this.batchChangeFailedPage = 1;
      this.batchChangeFailedDialogVisible = true;
    },
    handleBatchFailedKeywordChange() {
      this.batchChangeFailedPage = 1;
    },
    handleBatchFailedPageChange(page) {
      this.batchChangeFailedPage = page;
    },

    //显示编辑界面
    handleEdit() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }
      var row = rows[0];

      this.options = [];
      // 教学树必须固定到顶部学校，不能用班级或年级 ID 作为 scope。
      const schoolId = this.resolveActiveSchoolId();
      if (!schoolId) {
        this.$message.warning("请先选择学校");
        return;
      }

      this.editFormVisible = true;
      this.studentEditTab = 'basic';
      this.enrollmentTargetStatus = 1;
      this.enrollmentReason = '';
      this.editForm = Object.assign({}, row);
      // 先做基础清洗：全部转换为数字类型并排除 0（总平台）
      if (this.editForm.Dids) {
        this.editForm.Dids = this.editForm.Dids.map(id => Number(id)).filter(id => id !== 0);
      }
      // 如果StuPolitical为null，则赋值为空字符串
      if (this.editForm.StuPolitical === null) {
        this.editForm.StuPolitical = "";
      }

      let para = { pid: 0, scopeDepartmentId: schoolId };
      getTeachingDepartmentTree(para).then((res) => {
        ++this.isResouceShow;
        const root = res.data.response;
        const targetNode = this.findSchoolNode(root, schoolId);
        if (targetNode) {
          this.setPersonDeptCascaderOptions([targetNode]);
          const deptId = row.DepartmentId;
          this.fillPersonDeptPath('editForm', deptId);
          if (!(this.editForm.Dids && this.editForm.Dids.length)) {
            this.editForm.Dids = [targetNode.value];
          }
        } else {
          this.setPersonDeptCascaderOptions(root ? [root] : []);
          this.fillPersonDeptPath('editForm', row.DepartmentId);
        }
      });
      this.savedHeadPhotoImage = this.editForm.HeadPhotoImage || '';
      this.pendingAvatarFile = null;
      this.imageUrl = this.editForm.HeadPhotoImage;
      this.fillImageSizeForEditRow(row);

      let para01 = {
        id: row.DepartmentId,
      };
      getStudentLiveTypeList(para01).then((res) => {
        this.liveTypeList = res.data.response;
      });
      this.liveTypeId = this.editForm.LiveTypeId;
    },
    //显示新增界面
    handleAdd() {
      const schoolId = this.resolveActiveSchoolId();
      if (!schoolId) {
        this.$message.warning("请先选择学校");
        return;
      }
      this.addFormVisible = true;
      this.addPwdInputKey += 1;
      this.studentAddTab = 'basic';
      this.options = [];
      this.liveTypeId = "";
      var birthday = util.formatDate.format(new Date(), "yyyy-MM-dd");
      this.imageUrl = "";
      this.imageSizeKb = 0;
      this.resetAvatarState();
      this.addForm = {
        StuName: "",
        Birthday: birthday,
        StuNational: "",
        Sex: 1,
        HomeTown: "",
        Dids: [],
        DepartmentId: 0,
        IdCard: "",
        Height: "",
        Weight: "",
        CardNumber: "",
        Imei: "",
        BloodType: "",
        LiveTypeId: "",
        Account: "",
        Password: DEFAULT_LOGIN_PASSWORD,
        ContactPerson: "",
        ContactPhone: "",
        Address: "",
        StuPolitical: "",
        StuCode: "",
        ThirdPartyCode: "",
      };
      let para = { pid: 0, scopeDepartmentId: schoolId };
      getTeachingDepartmentTree(para).then((res) => {
        ++this.isResouceShow;
        const root = res.data.response;
        const targetNode = this.findSchoolNode(root, schoolId);
        if (targetNode) {
          this.setPersonDeptCascaderOptions([targetNode]);
        } else {
          this.setPersonDeptCascaderOptions(root ? [root] : []);
        }
        // 左侧已选「班级」时才预填；学校/年级只负责展开，需用户点到班级。最后更新：2026-08-26
        this.fillPersonDeptPath('addForm', this.DepartmentId, { requireClass: true });
        if (this.addForm.Dids && this.addForm.Dids.length) {
          this.handleChange(this.addForm.Dids);
        }
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          this.focusFormTabOnValidateFail('editForm', 'studentEditTab', this.studentAccountFieldProps());
          return;
        }
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.editLoading = true;
            try {
              const dids = (this.editForm.Dids || []).slice();
              const leafId = dids.length ? dids[dids.length - 1] : 0;
              const leafNode = this.findPersonDeptNodeById(this.options, leafId);
              if (!this.isPersonClassDeptNode(leafNode)) {
                this.editLoading = false;
                this.$message.warning('所属部门请选择班级');
                return;
              }
              const headPhotoImage = await this.ensureHeadPhotoUploaded(dids);
              this.editForm.HeadPhotoImage = headPhotoImage;
              let para = Object.assign({}, this.editForm);
              para.Birthday =
                !para.Birthday || para.Birthday == ""
                  ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                  : util.formatDate.format(new Date(para.Birthday), "yyyy-MM-dd");

              para.DepartmentId = para.Dids.pop();
              para.LiveTypeId = this.liveTypeId;
              const res = await editStudentInfo(para);
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.resetAvatarState();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
                this.editLoading = false;
              }
            } catch (e) {
              this.editLoading = false;
              this.$message.error((e && e.message) || '头像上传失败');
            }
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          this.focusFormTabOnValidateFail('addForm', 'studentAddTab', this.studentAccountFieldProps());
          return;
        }
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.addLoading = true;
            try {
              const dids = (this.addForm.Dids || []).slice();
              const leafId = dids.length ? dids[dids.length - 1] : 0;
              const leafNode = this.findPersonDeptNodeById(this.options, leafId);
              if (!this.isPersonClassDeptNode(leafNode)) {
                this.addLoading = false;
                this.$message.warning('所属部门请选择班级');
                return;
              }
              const headPhotoImage = await this.ensureHeadPhotoUploaded(dids);
              this.addForm.HeadPhotoImage = headPhotoImage;
              let para = Object.assign({}, this.addForm);
              para.Birthday =
                !para.Birthday || para.Birthday == ""
                  ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                  : util.formatDate.format(new Date(para.Birthday), "yyyy-MM-dd");

              para.DepartmentId = para.Dids.pop();

              para.LiveTypeId = this.liveTypeId;
              const res = await addStudentInfo(para);
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.resetAvatarState();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
                this.editLoading = false;
              }
            } catch (e) {
              this.addLoading = false;
              this.$message.error((e && e.message) || '头像上传失败');
            }
          });
        }
      });
    },

    //同步人员
    syncUser() {
      if (!this.isDingTalkSchool) {
        this.$message.warning('仅钉钉学校可同步钉钉人员')
        return
      }
      if (this.DepartmentId <= 0) {
        this.$message({
          message: "请选择要同步的部门！",
          type: "error",
        });
        return;
      }

      let message = `确认同步【${this.currentDepartment.label}】人员数据吗?`;
      if (this.bigType == 0) {
        message = `<b style="color:red">注意：非特殊情况无需同步“内部通讯录”的人员。</b><br><br>确认同步【${this.currentDepartment.label}】人员数据吗?`;
      }

      this.$confirm(message, "提示", {
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          let para = { id: this.DepartmentId };
          syncDingDingUser(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "异步同步成功,稍微等待一会刷新页面。",
                type: "success",
              });
            } else {
              // 将\n替换为<br>并启用HTML解析
              this.$message({
                message: `${res.data.msg ? res.data.msg.replace(/\n/g, '<br>') : '未知错误'}`,
                type: 'error',
                dangerouslyUseHTMLString: true
              });
            }
          });
        })
        .catch(() => { });
    },
    /** 重复组前端唯一键（钉钉组 / 同名组）。最后更新：2026-09-15 */
    duplicateGroupUiKey(group) {
      if (!group) return ''
      const type = group.GroupType || (group.groupType || 'DingTalk')
      const key = group.GroupKey != null ? group.GroupKey : (group.groupKey || '')
      return `${type}:${key}`
    },
    /** 是否同姓名重复组。最后更新：2026-09-15 */
    isDuplicateNameGroup(group) {
      if (!group) return false
      const type = group.GroupType || group.groupType || ''
      return String(type).toLowerCase() === 'name'
    },
    /** 同名组内可用于对照钉钉的 userid（组内唯一非空时）。最后更新：2026-09-15 */
    duplicateGroupDingCode(group) {
      if (!group || !group.Items || !group.Items.length) return ''
      if (!this.isDuplicateNameGroup(group)) return group.GroupKey || ''
      const codes = Array.from(new Set(
        group.Items
          .map(it => (it.ThirdPartyCode || '').trim())
          .filter(c => !!c)
      ))
      return codes.length === 1 ? codes[0] : ''
    },
    /**
     * 重复学生检测（同钉钉 ThirdPartyCode / 同姓名）。创建于 2026-09-03；最后更新：2026-09-15
     * options.resetFilter：打开弹窗时清空关键字并重新拉全量
     * options.resetPage：回到第 1 页
     * options.keepFilter：弹窗内刷新/翻页时保留当前关键字
     */
    async duplicateStudentCheck(options = {}) {
      if (this.DepartmentId <= 0) {
        this.$message.warning('请先在左侧选择部门后再检测！')
        return
      }
      // Toolbar 可能把按钮对象当成参数传入，忽略非业务 options
      const opt = (options && typeof options === 'object' && !Array.isArray(options) && options.Func == null)
        ? options
        : {}

      const opening = !this.duplicateDialogVisible
      // 每次从工具栏重新打开：清空上次查询条件，避免仍显示旧筛选结果
      if (opening || opt.resetFilter) {
        this.duplicateKeyword = ''
        this.duplicatePage = 1
      } else if (opt.resetPage) {
        this.duplicatePage = 1
      }

      this.duplicateDialogVisible = true
      this.duplicateLoading = true
      // 翻页/刷新时保留旧列表撑住高度，仅收起展开项；由面板 v-loading 过渡。最后更新：2026-09-15
      this.duplicateActiveGroups = []
      const seq = ++this.duplicateRequestSeq
      const requestPage = this.duplicatePage
      const keyword = (this.duplicateKeyword || '').trim()
      try {
        const res = await getDuplicateStudentWarnings({
          departmentId: this.DepartmentId,
          keyword: keyword || undefined,
          page: requestPage,
          intPageSize: this.duplicatePageSize,
          scopeByDepartment: !!this.duplicateScopeByDepartment
        })
        if (seq !== this.duplicateRequestSeq) return
        if (res.data.success) {
          const data = res.data.response || {}
          this.duplicateGroups = data.Items || data.items || []
          this.duplicateActiveGroups = []
          this.duplicateSummary.groupCount = data.GroupCount != null ? data.GroupCount : (data.groupCount || 0)
          this.duplicateSummary.studentCount = data.StudentCount != null ? data.StudentCount : (data.studentCount || 0)
          const serverPage = data.Page != null ? data.Page : data.page
          // 仅在服务端回写页码时静默对齐，避免再触发 current-change。最后更新：2026-09-15
          if (serverPage && serverPage !== this.duplicatePage) {
            this.duplicatePage = serverPage
          }
          if (this.duplicateSummary.groupCount === 0) {
            this.$message.success(res.data.msg || '未发现重复学生')
          }
        } else {
          this.duplicateGroups = []
          this.duplicateSummary.groupCount = 0
          this.duplicateSummary.studentCount = 0
          this.$message.error(res.data.msg || '检测失败')
        }
      } catch (e) {
        if (seq !== this.duplicateRequestSeq) return
        this.duplicateGroups = []
        this.duplicateSummary.groupCount = 0
        this.duplicateSummary.studentCount = 0
        this.$message.error('检测失败，请稍后重试')
      } finally {
        if (seq === this.duplicateRequestSeq) {
          this.duplicateLoading = false
        }
      }
    },
    /** 关键字查询（回到第 1 页）。创建于 2026-09-03 */
    handleDuplicateSearch() {
      this.duplicateStudentCheck({ resetPage: true, keepFilter: true })
    },
    /** 切换全校 / 按所选部门后立即重查。创建于 2026-09-15 */
    handleDuplicateScopeChange() {
      this.duplicateStudentCheck({ resetPage: true, keepFilter: true })
    },
    /** 清空关键字后立即重查全量。创建于 2026-09-03 */
    handleDuplicateClear() {
      this.duplicateKeyword = ''
      this.$nextTick(() => {
        this.duplicateStudentCheck({ resetPage: true, keepFilter: true })
      })
    },
    handleDuplicateSizeChange(val) {
      this.duplicatePageSize = val
      this.duplicatePage = 1
      this.duplicateStudentCheck({ keepFilter: true })
    },
    handleDuplicatePageChange(val) {
      this.duplicatePage = Number(val) || 1
      this.duplicateStudentCheck({ keepFilter: true })
    },
    formatDuplicateBalance(value) {
      return Number(value || 0).toFixed(2)
    },
    /** 钉钉对照摘要完整文案（悬停查看）。创建于 2026-09-03 */
    formatDuplicateDingSummary(cmp) {
      if (!cmp || !cmp.Found) return ''
      const parts = [`钉钉班级：${cmp.DingClassName || cmp.DingClassId || '-'}`]
      const guardians = cmp.Guardians || []
      if (guardians.length) {
        const texts = guardians.map(g => {
          const name = g.Name || '未命名'
          const rel = g.RelationName ? `(${g.RelationName})` : ''
          const uid = g.UserId ? ` 钉钉ID:${g.UserId}` : ''
          return `${name}${rel}${uid}`
        })
        parts.push(`监护人：${texts.join('、')}`)
      }
      return parts.join('；')
    },
    /** 门禁/德育等业务摘要。创建于 2026-09-03 */
    formatDuplicateBizSummary(row) {
      if (!row) return ''
      const parts = []
      if (row.HasFaceData) parts.push('人脸')
      if (row.AccessMappingCount > 0) parts.push('门禁下发')
      if (row.AccessRecordCount > 0) parts.push(`通行${row.AccessRecordCount}`)
      if (Number(row.MoralPoints) !== 0) parts.push(`德育分${Number(row.MoralPoints)}`)
      else if (row.MoralLedgerCount > 0) parts.push(`德育流水${row.MoralLedgerCount}`)
      if (row.LeaveCount > 0) parts.push(`请假${row.LeaveCount}`)
      return parts.join(' / ')
    },
    duplicateRiskTagType(tag) {
      const text = String(tag || '')
      if (text === '有余额' || text.indexOf('有通行') === 0 || text === '有人脸' || text === '有门禁下发') return 'danger'
      if (text.indexOf('有德育') === 0 || text.indexOf('有请假') === 0) return 'warning'
      if (text === '监护人姓名错乱' || text === '同名不同钉钉ID' || text === '无钉钉ID') return 'warning'
      if (text === '非在读' || text === '无监护人' || text === '无业务') return 'info'
      return 'success'
    },
    duplicateRecommendTagType(action) {
      if (action === 'keep') return 'success'
      if (action === 'delete') return 'danger'
      return 'warning'
    },
    /** 从重复检测结果删除学生档案。创建于 2026-09-03 */
    removeDuplicateStudent(item) {
      if (!item || !item.StudentId) return
      this.$confirm(
        `确认删除【${item.StuName || ''}】(ID:${item.StudentId}) 吗？\n建议保留在读且监护人正确的一条，删除旧班僵尸档。`,
        '提示',
        { type: 'warning' }
      )
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在校验关联业务并删除学生，请稍候…',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          removeStudentInfo({ id: item.StudentId })
            .then((res) => {
              if (res.data.success) {
                this.$message.success('删除成功')
                this.handleQuery()
                this.duplicateStudentCheck({ keepFilter: true })
              } else {
                this.$message.error(res.data.msg || '删除失败')
              }
            })
            .catch(() => {
              this.$message.error('删除失败，请稍后重试')
            })
            .finally(() => {
              loading.close()
            })
        })
        .catch(() => {})
    },
    /**
     * 对照钉钉当前班级与监护人（edu/user/get + relation/list）。创建于 2026-09-03；最后更新：2026-09-15
     */
    async compareDuplicateWithDingTalk(group) {
      if (!this.isDingTalkSchool) {
        this.$message.warning('非钉钉学校无法对照钉钉')
        return
      }
      const dingCode = this.duplicateGroupDingCode(group)
      if (!group || !dingCode) {
        this.$message.warning(this.isDuplicateNameGroup(group)
          ? '同名组钉钉 userid 不一致或为空，无法一键对照，请人工核对后删除'
          : '缺少钉钉 userid')
        return
      }
      if (this.DepartmentId <= 0) {
        this.$message.warning('请先选择部门')
        return
      }
      const uiKey = this.duplicateGroupUiKey(group)
      this.duplicateDingLoadingKey = uiKey
      try {
        const res = await compareDuplicateStudentWithDingTalk({
          departmentId: this.DepartmentId,
          thirdPartyCode: dingCode
        })
        if (!res.data.success) {
          this.$message.error(res.data.msg || '对照钉钉失败')
          return
        }
        const data = res.data.response || {}
        const compareItems = data.Items || data.items || []
        const map = {}
        compareItems.forEach((it) => {
          map[it.StudentId] = it
        })
        ;(group.Items || []).forEach((row) => {
          const hit = map[row.StudentId]
          if (!hit) return
          this.$set(row, 'ClassMatchDingTalk', hit.ClassMatchDingTalk)
          this.$set(row, 'ParentMatchDingTalk', hit.ParentMatchDingTalk)
          this.$set(row, 'RecommendAction', hit.RecommendAction)
          this.$set(row, 'RecommendText', hit.RecommendText)
          this.$set(row, 'RecommendReason', hit.RecommendReason)
          if (hit.RiskTags && hit.RiskTags.length) {
            const merged = Array.from(new Set([...(row.RiskTags || []), ...hit.RiskTags]))
            this.$set(row, 'RiskTags', merged)
          }
        })
        this.$set(group, '_dingCompare', data)
        this.$message.success(data.Message || res.data.msg || '对照完成')
      } catch (e) {
        this.$message.error('对照钉钉失败，请稍后重试')
      } finally {
        this.duplicateDingLoadingKey = ''
      }
    },
    /**
     * 合并：保留钉钉班级对齐档，迁入另一条正确监护人并删僵尸档。创建于 2026-09-03；最后更新：2026-09-15
     */
    mergeDuplicateGroup(group) {
      if (this.isDuplicateNameGroup(group) && !this.duplicateGroupDingCode(group)) {
        this.$message.warning('同名组钉钉 userid 不一致，不能自动合并，请人工删除僵尸档')
        return
      }
      const cmp = group && group._dingCompare
      if (!cmp || !cmp.CanMerge || !cmp.SuggestKeepStudentId || !cmp.SuggestDeleteStudentIds || !cmp.SuggestDeleteStudentIds.length) {
        this.$message.warning('当前组不满足自动合并条件，请先对照钉钉')
        return
      }
      const keepId = cmp.SuggestKeepStudentId
      const deleteId = cmp.MergeParentFromStudentId && cmp.SuggestDeleteStudentIds.indexOf(cmp.MergeParentFromStudentId) >= 0
        ? cmp.MergeParentFromStudentId
        : cmp.SuggestDeleteStudentIds[0]
      const parentFromId = cmp.MergeParentFromStudentId || deleteId
      this.$confirm(
        `将保留学生 Id=${keepId}（钉钉班级），从 Id=${parentFromId} 迁入正确监护人，并删除 Id=${deleteId}。是否继续？`,
        '合并重复学生',
        { type: 'warning' }
      )
        .then(async () => {
          this.duplicateMergeLoadingKey = this.duplicateGroupUiKey(group)
          try {
            const res = await mergeDuplicateStudents({
              DepartmentId: this.DepartmentId,
              KeepStudentId: keepId,
              DeleteStudentId: deleteId,
              ParentFromStudentId: parentFromId
            })
            if (res.data.success) {
              this.$message.success(res.data.msg || '合并成功')
              this.handleQuery()
              this.duplicateStudentCheck({ keepFilter: true })
            } else {
              this.$message.error(res.data.msg || '合并失败')
            }
          } catch (e) {
            this.$message.error('合并失败，请稍后重试')
          } finally {
            this.duplicateMergeLoadingKey = ''
          }
        })
        .catch(() => {})
    },
    /**
     * 将「导入学生照片」紧挨「导出学生照片」排列，便于更多操作里同一行展示。最后更新：2026-09-08
     */
    ensurePhotoImportAfterExport() {
      const list = this.buttonList || []
      const exportIdx = list.findIndex(item => item.Func === 'exportStudentPhotosZip')
      const importIdx = list.findIndex(item => item.Func === 'importStudentPhotosZip')
      if (exportIdx < 0 || importIdx < 0 || importIdx === exportIdx + 1) return
      const importBtn = list.splice(importIdx, 1)[0]
      const nextExportIdx = list.findIndex(item => item.Func === 'exportStudentPhotosZip')
      list.splice(nextExportIdx + 1, 0, importBtn)
    },
    /**
     * 打开导出学生照片命名规则弹窗。最后更新：2026-08-24
     */
    exportStudentPhotosZip() {
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择部门，再导出学生照片。");
        return;
      }
      this.photoNameDialogVisible = true;
    },
    /**
     * 打开导入学生照片弹窗（命名规则 + ZIP 上传）。最后更新：2026-09-08
     */
    importStudentPhotosZip() {
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择部门，再导入学生照片。");
        return;
      }
      this.photoImportNamePreset = this.photoNamePreset || "StuName_Id";
      this.photoImportCustomParts = [...(this.photoNameCustomParts || ["StuName", "Id"])];
      this.photoImportOverwrite = false;
      this.photoImportFileList = [];
      this.photoImportFileRaw = null;
      this.photoImportDialogVisible = true;
    },
    /** 选择导入命名预设。最后更新：2026-09-08 */
    selectPhotoImportNamePreset(val) {
      this.photoImportNamePreset = val;
      if (val === "custom") {
        if (!this.photoImportCustomParts || !this.photoImportCustomParts.length) {
          this.photoImportCustomParts = ["StuName", "Id"];
        }
        return;
      }
      this.photoImportCustomParts = String(val || "StuName_Id")
        .split("_")
        .filter(Boolean);
    },
    /** 导入自由搭配字段开关。最后更新：2026-09-08 */
    togglePhotoImportCustomPart(part) {
      const selected = new Set(this.photoImportCustomParts || []);
      if (selected.has(part)) {
        selected.delete(part);
      } else {
        selected.add(part);
      }
      this.photoImportCustomParts = ["StuName", "Id", "StuCode"].filter(key => selected.has(key));
    },
    /** ZIP 文件选择。最后更新：2026-09-08 */
    handlePhotoImportFileChange(file, fileList) {
      const list = (fileList || []).slice(-1);
      this.photoImportFileList = list;
      this.photoImportFileRaw = (list[0] && list[0].raw) || (file && file.raw) || null;
    },
    /** 移除 ZIP 文件。最后更新：2026-09-08 */
    handlePhotoImportFileRemove() {
      this.photoImportFileList = [];
      this.photoImportFileRaw = null;
    },
    /**
     * 确认规则与 ZIP 后提交异步导入任务。最后更新：2026-09-08
     */
    async confirmImportStudentPhotosZip() {
      const parts = this.resolvedPhotoImportNameParts;
      if (!parts.length) {
        this.$message.warning("请至少选择一个命名字段。");
        return;
      }
      if (!this.photoImportFileRaw) {
        this.$message.warning("请选择 ZIP 压缩包。");
        return;
      }
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择部门。");
        return;
      }

      this.photoImportSubmitting = true;
      try {
        const formData = new FormData();
        formData.append("file", this.photoImportFileRaw);
        formData.append("departmentId", String(this.DepartmentId));
        formData.append("photoNameParts", parts.join(","));
        formData.append("overwriteExisting", this.photoImportOverwrite ? "true" : "false");

        const res = await submitImportStudentPhotosZip(formData);
        if (!res.data || !res.data.success) {
          throw new Error((res.data && res.data.msg) || "提交导入任务失败");
        }
        const payload = res.data.response || {};
        const jobId = payload.jobId || payload.JobId;
        if (!jobId) {
          throw new Error("未获取到任务 ID");
        }

        this.photoImportDialogVisible = false;
        this.photoImportJobId = jobId;
        this.handlePhotoImportFileRemove();
        this.startPhotoImportProgress();
      } catch (error) {
        this.$message.error((error && error.message) || "提交失败，请重试");
      } finally {
        this.photoImportSubmitting = false;
      }
    },
    /** 启动导入进度轮询。最后更新：2026-09-08 */
    startPhotoImportProgress() {
      this.clearPhotoImportProgress();
      this.photoImportModalVisible = true;
      this.photoImportPercent = 2;
      this.photoImportServerStatus = "Pending";
      this.photoImportServerStage = "Pending";
      this.photoImportServerMessage = "任务已提交，等待后台处理…";
      this.photoImportTotalFiles = 0;
      this.photoImportProcessedFiles = 0;
      this.photoImportSuccessCount = 0;
      this.photoImportFailCount = 0;
      this.photoImportErrorMsg = "";
      this.pollPhotoImportStatus();
      this.photoImportPollTimer = setInterval(() => this.pollPhotoImportStatus(), 2000);
    },
    /** 轮询导入任务状态。最后更新：2026-09-08 */
    async pollPhotoImportStatus() {
      if (!this.photoImportJobId) return;
      try {
        const res = await getImportStudentPhotosZipStatus({ jobId: this.photoImportJobId });
        if (!res.data || !res.data.success) {
          return;
        }
        const dto = res.data.response || {};
        this.photoImportServerStatus = dto.status || dto.Status || "";
        this.photoImportServerStage = dto.stage || dto.Stage || "";
        const percent = dto.percent != null ? dto.percent : dto.Percent;
        if (percent != null) {
          this.photoImportPercent = percent;
        }
        this.photoImportTotalFiles = dto.totalFiles != null ? dto.totalFiles : (dto.TotalFiles || 0);
        this.photoImportProcessedFiles = dto.processedFiles != null ? dto.processedFiles : (dto.ProcessedFiles || 0);
        this.photoImportSuccessCount = dto.successCount != null ? dto.successCount : (dto.SuccessCount || 0);
        this.photoImportFailCount = dto.failCount != null ? dto.failCount : (dto.FailCount || 0);
        this.photoImportServerMessage = dto.message || dto.Message || "";

        const statusLower = String(this.photoImportServerStatus || "").toLowerCase();
        if (statusLower === "completed") {
          this.finishPhotoImportSuccess(dto);
        } else if (statusLower === "failed") {
          this.finishPhotoImportError(dto.message || dto.Message || "导入失败");
        }
      } catch (e) {
        // 轮询偶发失败忽略，下次继续
      }
    },
    /** 导入成功收尾。最后更新：2026-09-08 */
    finishPhotoImportSuccess(dto) {
      this.clearPhotoImportProgress();
      this.photoImportPercent = 100;
      this.photoImportServerStatus = "Completed";

      const result = (dto && (dto.result || dto.Result)) || null;
      this.photoImportResult = result;

      const failCount = result
        ? (result.failCount != null ? result.failCount : (result.FailCount || 0))
        : this.photoImportFailCount;
      const successCount = result
        ? (result.successCount != null ? result.successCount : (result.SuccessCount || 0))
        : this.photoImportSuccessCount;
      const summary = result && (result.summary || result.Summary);
      let okMsg = summary || `导入完成：成功 ${successCount} 张`;
      if (failCount > 0) {
        okMsg += `，失败 ${failCount} 张（可查看明细）`;
      }
      this.$message.success(okMsg);
      this.handleQuery();

      const failures = result && (result.failures || result.Failures);
      if (failCount > 0 || (Array.isArray(failures) && failures.length)) {
        this.photoImportResultDialogVisible = true;
      }

      this.photoImportCloseTimeout = setTimeout(() => {
        this.photoImportModalVisible = false;
      }, 1500);
    },
    /** 导入失败收尾。最后更新：2026-09-08 */
    finishPhotoImportError(msg) {
      this.clearPhotoImportProgress();
      this.photoImportServerStatus = "Failed";
      this.photoImportErrorMsg = msg || "导入失败，请重试";
      this.$message.error(this.photoImportErrorMsg);
    },
    /** 清除导入轮询定时器。最后更新：2026-09-08 */
    clearPhotoImportProgress() {
      if (this.photoImportPollTimer) {
        clearInterval(this.photoImportPollTimer);
        this.photoImportPollTimer = null;
      }
      if (this.photoImportCloseTimeout) {
        clearTimeout(this.photoImportCloseTimeout);
        this.photoImportCloseTimeout = null;
      }
    },
    /** 关闭导入进度弹窗。最后更新：2026-09-08 */
    closePhotoImportModal() {
      this.clearPhotoImportProgress();
      this.photoImportModalVisible = false;
      this.photoImportJobId = "";
      this.photoImportPercent = 0;
      this.photoImportServerStatus = "";
      this.photoImportServerStage = "";
      this.photoImportServerMessage = "";
      this.photoImportErrorMsg = "";
    },
    /**
     * 选择命名预设。最后更新：2026-08-24
     */
    selectPhotoNamePreset(val) {
      this.photoNamePreset = val;
      this.onPhotoNamePresetChange(val);
    },
    /**
     * 快捷预设切换时，同步自定义勾选便于预览。最后更新：2026-08-24
     */
    onPhotoNamePresetChange(val) {
      if (val === "custom") {
        if (!this.photoNameCustomParts || !this.photoNameCustomParts.length) {
          this.photoNameCustomParts = ["StuName", "Id"];
        }
        return;
      }
      this.photoNameCustomParts = String(val || "StuName_Id")
        .split("_")
        .filter(Boolean);
    },
    /**
     * 自由搭配字段开关。最后更新：2026-08-24
     */
    togglePhotoNameCustomPart(part) {
      const selected = new Set(this.photoNameCustomParts || []);
      if (selected.has(part)) {
        selected.delete(part);
      } else {
        selected.add(part);
      }
      this.photoNameCustomParts = ["StuName", "Id", "StuCode"].filter(key => selected.has(key));
    },
    /**
     * 确认命名规则后开始导出。最后更新：2026-08-24
     */
    confirmExportStudentPhotosZip() {
      const parts = this.resolvedPhotoNameParts;
      if (!parts.length) {
        this.$message.warning("请至少选择一个命名字段。");
        return;
      }
      this.photoNameDialogVisible = false;
      this.doExportStudentPhotosZip(parts);
    },
    /**
     * 启动学生照片导出进度定时器（多阶段平滑步进）。最后更新：2026-09-08
     */
    startPhotoExportProgress() {
      this.clearPhotoExportProgress();
      this.photoExportModalVisible = true;
      this.photoExportStatus = "scanning";
      this.photoExportPercent = 4;
      this.photoExportErrorMsg = "";
      this.photoExportTransferDetail = "";

      // 阶段 1 (0% ~ 35%)：扫描磁盘校验；阶段 2 (35% ~ 78%)：流式极速归档打包
      this.photoExportTimer = setInterval(() => {
        if (this.photoExportStatus === "scanning") {
          if (this.photoExportPercent < 35) {
            this.photoExportPercent += 1;
          } else {
            this.photoExportStatus = "zipping";
          }
        } else if (this.photoExportStatus === "zipping") {
          if (this.photoExportPercent < 78) {
            this.photoExportPercent += 1;
          }
        }
      }, 85);
    },
    /**
     * 清除学生照片导出进度定时器。最后更新：2026-09-08
     */
    clearPhotoExportProgress() {
      if (this.photoExportTimer) {
        clearInterval(this.photoExportTimer);
        this.photoExportTimer = null;
      }
      if (this.photoExportCloseTimeout) {
        clearTimeout(this.photoExportCloseTimeout);
        this.photoExportCloseTimeout = null;
      }
    },
    /**
     * 关闭学生照片导出专属进度弹窗。最后更新：2026-09-08
     */
    closePhotoExportModal() {
      this.clearPhotoExportProgress();
      this.photoExportModalVisible = false;
      this.photoExportStatus = "scanning";
      this.photoExportPercent = 0;
      this.photoExportErrorMsg = "";
      this.photoExportTransferDetail = "";
    },
    /**
     * 从服务端打包学生头像为 ZIP（按班级文件夹）；范围与列表一致，仅传 departmentId、筛选条件与命名规则。最后更新：2026-09-08
     */
    async doExportStudentPhotosZip(photoNameParts) {
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择部门，再导出学生照片。");
        return;
      }
      this.startPhotoExportProgress();
      try {
        const para = {
          departmentId: this.DepartmentId,
          ...this.filters,
          photoNameParts: (photoNameParts || []).join(","),
        };
        const response = await requestStudentPhotosZipExport(para, {
          onDownloadProgress: (progressEvent) => {
            // 真实下载进度监听：进入数据传输阶段 (78% ~ 99%)
            if (this.photoExportStatus !== "downloading") {
              this.photoExportStatus = "downloading";
            }
            const loaded = progressEvent.loaded || 0;
            const total = progressEvent.total || 0;
            const loadedMb = (loaded / 1024 / 1024).toFixed(1);

            if (total > 0) {
              const totalMb = (total / 1024 / 1024).toFixed(1);
              this.photoExportTransferDetail = `已传输 ${loadedMb} / ${totalMb} MB`;
              const ratio = Math.min(1, Math.max(0, loaded / total));
              this.photoExportPercent = Math.min(99, Math.round(78 + ratio * 21));
            } else if (loaded > 0) {
              this.photoExportTransferDetail = `已传输 ${loadedMb} MB`;
              if (this.photoExportPercent < 98) {
                this.photoExportPercent = Math.min(98, 78 + Math.floor(Math.log10(loaded / 1024 + 1) * 4));
              }
            }
          },
        });

        if (!response || typeof response.status !== "number" || !response.config) {
          const msg =
            (response && (response.msg || response.message)) || "导出失败";
          throw new Error(msg);
        }

        const ct =
          (response.headers &&
            (response.headers["content-type"] || response.headers["Content-Type"])) ||
          "";
        if (ct.includes("application/json")) {
          const msg = await this.parseExportBlobErrorMsg(response.data);
          throw new Error(msg || "导出失败");
        }

        if (!response.data || (response.data.size != null && response.data.size === 0)) {
          throw new Error("导出文件为空，未检索到有效学生照片。");
        }

        const added = response.headers["x-export-student-photos-added"] || response.headers["X-Export-Student-Photos-Added"];
        const skipped = response.headers["x-export-student-photos-skipped"] || response.headers["X-Export-Student-Photos-Skipped"];

        // 切换为 100% 成功状态
        this.clearPhotoExportProgress();
        this.photoExportStatus = "success";
        this.photoExportPercent = 100;
        this.photoExportTransferDetail = "";

        // 唤起浏览器保存文件
        const blob = new Blob([response.data], { type: "application/zip" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `学生照片_${this.formatZipTimeStamp()}.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        let ok = "已开始下载学生照片压缩包。";
        if (added || skipped) {
          ok += ` 成功 ${added || 0} 张`;
          if (skipped && Number(skipped) > 0) {
            ok += `，跳过缺失 ${skipped} 条（可在 ZIP 根目录下查看缺失名单报告）`;
          }
        }
        this.$message.success(ok);

        // 智能自动关闭：延时 1.5 秒平滑关闭进度弹窗
        this.photoExportCloseTimeout = setTimeout(() => {
          this.photoExportModalVisible = false;
        }, 1500);

      } catch (error) {
        this.clearPhotoExportProgress();
        this.photoExportStatus = "error";

        let errorMsg = "";
        if (error && error.bizMessage) {
          errorMsg = error.bizMessage;
        } else if (error && error.response && error.response.data instanceof Blob) {
          errorMsg = await this.parseExportBlobErrorMsg(error.response.data);
        } else if (error && typeof error === "object" && (error.msg || error.message) && !error.config) {
          errorMsg = error.msg || error.message;
        } else {
          errorMsg = (error && error.message) || "";
        }

        if (errorMsg.indexOf("timeout") > -1) {
          errorMsg = "导出超时：全校照片体积较大，请检查网络或缩小部门范围重试。";
        }

        this.photoExportErrorMsg = errorMsg || "导出失败，请重试";
        this.$message.error(this.photoExportErrorMsg);
      }
    },
    formatZipTimeStamp() {
      const d = new Date();
      const p = (n) => (n < 10 ? "0" + n : "" + n);
      return (
        d.getFullYear() +
        p(d.getMonth() + 1) +
        p(d.getDate()) +
        p(d.getHours()) +
        p(d.getMinutes()) +
        p(d.getSeconds())
      );
    },
    async parseExportBlobErrorMsg(blob) {
      try {
        const text = await new Response(blob).text();
        const j = JSON.parse(text);
        return j.msg || j.message || j.Message || "";
      } catch (e) {
        return "";
      }
    },
    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
        };

        var fileName = "人员信息";
        const response = await exportStudentInfo(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
        this.$message({
          message: "导出失败",
          type: "error",
        });
      }
    },

    handleRemoveAvatar() {
      this.resetAvatarState();
      if (this.editForm) this.editForm.HeadPhotoImage = '';
      if (this.addForm) this.addForm.HeadPhotoImage = '';
    },
    // 调起导入学生
    ImportCensus() {
      this.resetStudentImportDialog();
      this.studentImportDialogVisible = true;
    },
    resetStudentImportDialog() {
      this.studentImportFileRaw = null;
      this.studentImportParsing = false;
      this.studentImportUploadKey += 1;
    },
    onStudentImportDialogClosed() {
      if (this.studentImportKeepFileOnClose) {
        this.studentImportKeepFileOnClose = false;
        return;
      }
      this.resetStudentImportDialog();
    },
    backToStudentImportSelect() {
      this.excelShow = false;
      this.studentImportDialogVisible = true;
    },
    onStudentImportFileChange(file) {
      this.studentImportFileRaw = file && file.raw ? file.raw : null;
    },
    onStudentImportFileRemove() {
      this.studentImportFileRaw = null;
    },
    onStudentImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.studentImportUploadKey += 1;
      this.$nextTick(() => {
        this.studentImportFileRaw = nextFile;
      });
    },
    downloadStudentImportTemplate() {
      const headers = [
        '所属部门', '学生ID', '姓名', '学号', '号次', '性别',
        '联系电话', '卡号', '照片路径', '类型', '用户类型', '第三方ID'
      ];
      const sample = [
        '一年级1班', '', '张三', '2026001', '1', '男',
        '13800000000', '', '', '走读', '', ''
      ];
      const sheet = utils.aoa_to_sheet([headers, sample]);
      const book = utils.book_new();
      utils.book_append_sheet(book, sheet, '学生导入');
      writeFile(book, '学生批量导入模板.xlsx');
    },
    parseStudentImportFile() {
      if (!this.studentImportFileRaw) {
        this.$message.warning('请先选择 Excel 文件');
        return;
      }
      this.readExcelFile(this.studentImportFileRaw);
    },
    // 调起导入监护人（打开模态框）
    ImportParent() {
      if (!this.DepartmentId || this.DepartmentId <= 0) {
        this.$message.warning('请选择具体部门后再进行监护人导入/导出，平台级别不可操作');
        return;
      }
      this.resetParentImportDialog();
      this.parentImportDialogVisible = true;
    },
    // 兼容旧调用：打开导入监护人模态框
    openParentImportDialog() {
      this.ImportParent();
    },
    resetParentImportDialog() {
      this.parentImportFileRaw = null;
      this.parentImportParsing = false;
      this.parentImportUploadKey += 1;
    },
    onParentImportDialogClosed() {
      if (this.parentImportKeepFileOnClose) {
        this.parentImportKeepFileOnClose = false;
        return;
      }
      this.resetParentImportDialog();
    },
    backToParentImportSelect() {
      this.parentExcelShow = false;
      this.parentImportDialogVisible = true;
    },
    onParentImportFileChange(file) {
      this.parentImportFileRaw = file && file.raw ? file.raw : null;
    },
    onParentImportFileRemove() {
      this.parentImportFileRaw = null;
    },
    onParentImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.parentImportUploadKey += 1;
      this.$nextTick(() => {
        this.parentImportFileRaw = nextFile;
      });
    },
    parseParentImportFile() {
      if (!this.parentImportFileRaw) {
        this.$message.warning('请先选择 Excel 文件');
        return;
      }
      this.readParentExcelFile(this.parentImportFileRaw);
    },
    // 下载监护人导入模板（通过后端接口，支持按当前筛选参数）
    async downloadParentTemplate() {
      if (!this.DepartmentId || this.DepartmentId <= 0) {
        this.$message.warning('请选择具体部门后再导出监护人模板，平台级别不可导出');
        return;
      }
      const para = {
        departmentId: this.DepartmentId,
      };
      this.exportLoading = true;
      try {
        const res = await exportStudentParentTemplate(para);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '导入监护人模板.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        this.$message.error('模板下载失败');
      } finally {
        this.exportLoading = false;
      }
    },
    //删除错误行
    removeImport(e) {
      const name = (e.row && (e.row.Name || e.row.UserName)) || '该学生';
      this.$confirm('确定要删除「' + name + '」吗？').then(() => {
        this.outputs.splice(e['$index'], 1);
      });
    },
    // 保存学生导入信息
    SavaImport() {
      const schoolDepartmentId = this.resolveActiveSchoolId();
      if (!schoolDepartmentId) {
        this.$message.warning('请先在顶部选择学校');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '导入中',
        background: 'rgba(0,0,0,0.7)'
      });
      importStudentCardList({
        schoolDepartmentId: schoolDepartmentId,
        items: this.outputs,
      })
        .then((res) => {
          loading.close();
          if (res.data && res.data.success) {
            this.excelShow = false;
            this.handleQuery();
            this.showStudentImportResult(res.data, 'success');
          } else {
            this.showStudentImportResult(res.data, 'error');
          }
        })
        .catch(() => {
          loading.close();
          this.$message.error('导入失败');
        });
    },
    /** 展示导入结果弹窗（结构化 response）。最后更新：2026-09-02 */
    showStudentImportResult(resData, type) {
      this.importResult = (resData && resData.response) || null;
      this.studentImportResultDialogVisible = true;
      const normalized = normalizeImportBatchResponse(resData || {});
      if (!normalized.items.length) {
        const text = normalized.summary || (resData && resData.msg) || '';
        if (type === 'error') {
          this.$message.error(text || '导入失败');
        } else if (type === 'success') {
          this.$message.success(text || '导入完成');
        }
      }
    },
    // 保存信息
    async SavaParentImport() {
      if (!Array.isArray(this.parentOutputs) || this.parentOutputs.length === 0) {
        this.$message.warning('没有要导入的数据');
        return;
      }
      const loading = this.$loading({ lock: true, text: '导入中', background: 'rgba(0,0,0,0.7)' });
      try {
        // parentOutputs 已改为每个学生一行，包含 Parent1..Parent5 字段
        const payloads = [];
        this.parentOutputs.forEach(row => {
          const stuId = row.StuId || '';
          for (let i = 1; i <= 5; i++) {
            const name = row[`Parent${i}Name`] || '';
            const rel = row[`Parent${i}RelationDesc`] || '';
            const phone = row[`Parent${i}Msisdn`] || '';
            const plates = row[`Parent${i}Plates`] || '';
            const parentId = row[`Parent${i}Id`] || '';
            const thirdPartyCode = row[`Parent${i}ThirdPartyCode`] || '';
            if (name || rel || phone || String(plates).trim() || String(parentId).trim() || String(thirdPartyCode).trim()) {
              payloads.push({
                StuId: stuId,
                ParentId: parentId,
                ParentName: name,
                ParentRelationDesc: rel,
                ParentMsisdn: phone,
                ParentPlates: plates,
                ThirdPartyCode: thirdPartyCode,
              });
            }
          }
        });

        if (payloads.length === 0) {
          loading.close();
          this.$message.warning('没有有效的家长数据要导入');
          return;
        }

        // 使用后端批量接口一次性导入所有家长数据
        const res = await importStudentParentBatch(payloads);
        loading.close();
        if (res && res.data && res.data.success) {
          this.$message({ message: res.data.msg || '导入完成', type: 'success' });
          this.parentExcelShow = false;
          this.handleQuery();
        } else {
          const msg = (res && res.data && res.data.msg) || (res && res.message) || '导入失败';
          this.$message({ message: msg, type: 'error' });
        }
      } catch (e) {
        loading.close();
        const errMsg = (e && (e.message || e.bizMessage)) || '';
        if (errMsg.indexOf('timeout') > -1 || (e && e.code === 'ECONNABORTED')) {
          this.$message({ message: '导入耗时较长，请稍后在列表中确认是否已成功；若未成功可缩小批次后重试', type: 'warning', duration: 6000 });
        } else {
          this.$message({ message: errMsg || '导入失败', type: 'error' });
        }
      }
    },

    removeParentImport(e) {
      this.$confirm('确定要删除此条记录吗？').then(() => {
        this.parentOutputs.splice(e['$index'], 1)
      })
    },
    readParentExcelFile(file) {
      if (!file) return;
      if (!/\.(xls|xlsx)$/.test(String(file.name || '').toLowerCase())) {
        this.$message.error('上传格式不正确,请上传xls或者xlsx格式');
        return;
      }
      this.parentImportParsing = true;
      const loading = this.$loading({ lock: true, text: '正在读取文件', background: 'rgba(0,0,0,0.7)' });
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = read(data, { type: 'binary' });
          const wsname = workbook.SheetNames[0];
          const sheet = workbook.Sheets[wsname];
          const ws = utils.sheet_to_json(sheet);
          const headerArrAll = utils.sheet_to_json(sheet, { header: 1 }) || [];
          const headerRow = headerArrAll.length > 0 ? headerArrAll[0] : [];
          loading.close();
          this.parentImportParsing = false;
          this.parentOutputs = this.reSetParentKey(ws, headerRow);
          this.parentImportKeepFileOnClose = true;
          this.parentImportDialogVisible = false;
          this.$nextTick(() => {
            this.parentExcelShow = true;
          });
        } catch (err) {
          loading.close();
          this.parentImportParsing = false;
          this.$message.error('文件读取失败');
        }
      };
      fileReader.onerror = () => {
        loading.close();
        this.parentImportParsing = false;
        this.$message.error('文件读取失败');
      };
      fileReader.readAsBinaryString(file);
    },
    reSetParentKey(ws, headerRow) {
      const out = [];

      // 尝试从多种候选 key 取值，包含去空格和大小写容错
      const tryGet = (obj, keys) => {
        if (!obj) return '';
        for (const k of keys) {
          if (k in obj && obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') return String(obj[k]).trim();
        }
        const objKeys = Object.keys(obj || {});
        for (const k of keys) {
          const m = objKeys.find(x => x && x.toString().trim() === k);
          if (m && obj[m] !== undefined && obj[m] !== null && String(obj[m]).trim() !== '') return String(obj[m]).trim();
        }
        for (const k of keys) {
          const m = objKeys.find(x => x && x.toString().toLowerCase() === k.toLowerCase());
          if (m && obj[m] !== undefined && obj[m] !== null && String(obj[m]).trim() !== '') return String(obj[m]).trim();
        }
        return '';
      };

      // 预构建表头规范映射（使用传入的 headerRow 优先）
      const normalize = (s) => (s || '').toString().replace(/\s+/g, '').toLowerCase().replace(/[^0-9a-z\u4e00-\u9fa5]/g, '');
      const headerMap = {};
      if (Array.isArray(headerRow) && headerRow.length > 0) {
        headerRow.forEach(k => { headerMap[normalize(k)] = k; });
      } else if (ws && ws.length > 0) {
        Object.keys(ws[0]).forEach(k => { headerMap[normalize(k)] = k; });
      }

      // 表头含「家长1…」等列时走多列解析，避免单行家长逻辑先占掉 parents[0]（例如 家长1车牌 同时命中 singleParentPlates）
      const hasNumberedParentHeaders = Object.keys(headerMap).some(nk => /家长[1-9]/.test(nk));

      const tryGetNormalized = (obj, candidates) => {
        if (!obj) return '';
        for (const c of candidates) {
          const nk = normalize(c);
          if (nk && headerMap[nk]) {
            const orig = headerMap[nk];
            const v = obj[orig];
            if (v !== undefined && v !== null && String(v).trim() !== '') return String(v).trim();
          }
        }
        return tryGet(obj, candidates);
      };

      ws.forEach(item => {
        const stuId = tryGetNormalized(item, ['学生ID', 'StudentId', 'Student ID', '学生 Id']);
        const stuName = tryGetNormalized(item, ['学生姓名', '姓名', 'Name', 'StuName']);
        const className = tryGetNormalized(item, ['班级名称', 'ClassName', 'Class', '班级']);

        // 收集父母信息：有「家长1…」列时仅用下方多列模式；否则兼容旧模板单行家长列
        const parents = [];
        if (!hasNumberedParentHeaders) {
          const singleParentName = tryGetNormalized(item, ['家长姓名', '姓名', 'ParentName']);
          const singleParentRel = tryGetNormalized(item, ['关系', 'Relation', 'ParentRelationDesc']);
          const singleParentPhone = tryGetNormalized(item, ['联系电话', 'Phone', 'ParentMsisdn']);
          const singleParentPlates = tryGetNormalized(item, ['家长车牌', '车牌', '车牌号', 'ParentPlates']);
          if (singleParentName || singleParentRel || singleParentPhone || singleParentPlates) {
            parents.push({ id: '', name: singleParentName || '', rel: singleParentRel || '', phone: singleParentPhone || '', plates: singleParentPlates || '' });
          }
        }

        // 家长1..5 列（含记录ID，与导出模板一致）
        for (let i = 1; i <= 5; i++) {
          const idCandidates = [`家长${i}记录ID`, `Parent${i}Id`, `家长 ${i} 记录ID`];
          const nameCandidates = [`家长${i}姓名`, `Parent${i}Name`, `家长 ${i} 姓名`];
          const relCandidates = [`家长${i}与学生关系`, `家长${i}与学生 关系`, `Parent${i}Relation`, `家长${i}关系`];
          const phoneCandidates = [`家长${i}手机号`, `家长${i}手机`, `Parent${i}Phone`];
          const plateCandidates = [`家长${i}车牌`, `家长${i}车 牌`, `Parent${i}Plate`, `Parent${i}Plates`];
          const codeCandidates = [`家长${i}第三方ID`, `家长${i}第三方 ID`, `Parent${i}ThirdPartyCode`, `Parent${i}ThirdPartyCode`];
          const pid = tryGetNormalized(item, idCandidates);
          const name = tryGetNormalized(item, nameCandidates);
          const rel = tryGetNormalized(item, relCandidates);
          const phone = tryGetNormalized(item, phoneCandidates);
          const plates = tryGetNormalized(item, plateCandidates);
          const code = tryGetNormalized(item, codeCandidates);
          if (pid || name || rel || phone || plates || code) {
            parents.push({ id: pid || '', name: name || '', rel: rel || '', phone: phone || '', plates: plates || '', thirdPartyCode: code || '' });
          }
        }

        // 如果该行至少有学生信息或父母信息，则输出一行（每行包含 Parent1..Parent5）
        if (stuId || stuName || className || parents.length > 0) {
          const outRow = {
            StuId: stuId || '',
            StuName: stuName || '',
            ClassName: className || ''
          };
          for (let i = 1; i <= 5; i++) {
            const p = parents[i - 1] || { id: '', name: '', rel: '', phone: '', plates: '' };
            outRow[`Parent${i}Id`] = p.id || '';
            outRow[`Parent${i}Name`] = p.name || '';
            outRow[`Parent${i}RelationDesc`] = p.rel || '';
            outRow[`Parent${i}Msisdn`] = p.phone || '';
            outRow[`Parent${i}Plates`] = p.plates || '';
            outRow[`Parent${i}ThirdPartyCode`] = p.thirdPartyCode || '';
          }
          out.push(outRow);
        }
      });

      return out;
    },
    readExcelFile(file) {
      if (!file) return;
      if (!/\.(xls|xlsx)$/.test(String(file.name || '').toLowerCase())) {
        this.$message.error('上传格式不正确,请上传xls或者xlsx格式');
        return;
      }
      this.studentImportParsing = true;
      const loading = this.$loading({
        lock: true,
        text: '正在读取文件',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = read(data, { type: 'binary' });
          const wsname = workbook.SheetNames[0];
          const ws = utils.sheet_to_json(workbook.Sheets[wsname]);
          loading.close();
          this.studentImportParsing = false;
          this.outputs = this.reSetKey(ws);
          this.studentImportKeepFileOnClose = true;
          this.studentImportDialogVisible = false;
          this.$nextTick(() => {
            this.excelShow = true;
          });
        } catch (e) {
          loading.close();
          this.studentImportParsing = false;
          this.$message.error('文件读取失败');
        }
      };
      fileReader.onerror = () => {
        loading.close();
        this.studentImportParsing = false;
        this.$message.error('文件读取失败');
      };
      fileReader.readAsBinaryString(file);
    },
    reSetKey(ws) {
      let temp = []
      ws.forEach((item) => {
        const hasThirdPartyCol =
          Object.prototype.hasOwnProperty.call(item, '第三方ID') ||
          Object.prototype.hasOwnProperty.call(item, '第三方账号') ||
          Object.prototype.hasOwnProperty.call(item, 'ThirdPartyCode')
        const row = {
          Department: item['所属部门'] || item['部门'] || item['班级'] || '',
          StudentId: item['学生ID'] || '',
          Name: item['姓名'] || '',
          Sex: item['性别'] || '',
          ContactPhone: item['联系电话'] || item['联系号码'] || item['ContactPhone'] || '',
          Card: item['卡号'] || '',
          PhotoPath: item['照片路径'] || '',
          Type: item['类型'] || '',
          StuPolitical: item['用户类型'] || '',
          StuCode: item['学号'] || '',
          SeatNumber: item['号次'] || item['座位号'] || item['座位'] || item['SeatNumber'] || ''
        }
        if (hasThirdPartyCol) {
          // 不用 ??，兼容当前项目 Babel（避免 nullish coalescing 未转译报错）
          let thirdPartyVal = item['第三方ID']
          if (thirdPartyVal == null) thirdPartyVal = item['第三方账号']
          if (thirdPartyVal == null) thirdPartyVal = item['ThirdPartyCode']
          if (thirdPartyVal == null) thirdPartyVal = ''
          row.ThirdPartyCode = String(thirdPartyVal).trim()
        }
        temp.push(row)
      })
      return temp
    },

    migrateLocalAvatarToOss() {
      this.localAvatarMigrateVisible = true
    },
    onLocalAvatarMigrateDone() {
      this.handleQuery()
    },
    openHeadPhotoCompress() {
      this.headPhotoCompressVisible = true
    },
    onHeadPhotoCompressDone() {
      this.handleQuery()
    },
    async refreshOssAvatarMigrateEnabled() {
      const deptId = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId')
      if (!deptId) {
        this.ossAvatarEnabled = false
        this.updateMigrateButtonVisibility()
        return
      }
      try {
        const res = await getStudentLocalAvatarMigrateStatus({ departmentId: String(deptId) })
        this.ossAvatarEnabled = !!(res.data.success && res.data.response && res.data.response.Enabled)
      } catch (e) {
        this.ossAvatarEnabled = false
      }
      this.updateMigrateButtonVisibility()
    },
    updateMigrateButtonVisibility() {
      const btn = (this.buttonList || []).find(item => String(item.Func || '').toLowerCase() === 'migratelocalavatartooss')
      if (btn) this.$set(btn, 'IsHide', !this.ossAvatarEnabled)
    },
    /**
     * 表格高度 100% 时，父容器定高后再重算表体，避免固定操作列被裁切。最后更新：2026-08-27
     */
    relayoutPersonTable() {
      this.$nextTick(() => {
        const table = this.$refs.table
        if (table && typeof table.doLayout === 'function') table.doLayout()
      })
    },

  },
  watch: {
    '$store.state.activeSchoolId'() {
      this.refreshOssAvatarMigrateEnabled()
      this.loadCurrentSchoolSchType()
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 仅预隐藏「同步钉钉*」，绝不动头像迁移 OSS
    ;(this.buttonList || []).forEach(btn => {
      if (this.isDingTalkSyncToolbarButton(btn)) {
        const func = String(btn.Func || '').toLowerCase()
        if (/migrate|compress|qrcode/.test(func)) return
        this.$set(btn, 'IsHide', true)
      }
    })

    if (!this.buttonList.some(item => item.Func === 'migrateLocalAvatarToOss')) {
      this.buttonList.push({
        name: '头像迁移OSS',
        Func: 'migrateLocalAvatarToOss',
        id: 996,
        IsHide: true,
        btnType: 'warning'
      })
    }
    if (!this.buttonList.some(item => item.Func === 'openHeadPhotoCompress')) {
      this.buttonList.push({
        name: '头像压缩',
        Func: 'openHeadPhotoCompress',
        id: 995,
        IsHide: false,
        btnType: 'warning'
      })
    }
    if (!this.buttonList.some(item => item.Func === 'openStudentQrCodeDialog')) {
      this.buttonList.push({
        name: '学生二维码',
        Func: 'openStudentQrCodeDialog',
        id: 997,
        btnType: 'primary'
      })
    }
    if (!this.buttonList.some(item => item.Func === 'duplicateStudentCheck')) {
      this.buttonList.push({
        name: '重复检测',
        Func: 'duplicateStudentCheck',
        id: 994,
        IsHide: true,
        btnType: 'warning',
        icon: 'el-icon-warning-outline'
      })
    }
    if (!this.buttonList.some(item => item.Func === 'importStudentPhotosZip')) {
      const importBtn = {
        name: '导入学生照片',
        Func: 'importStudentPhotosZip',
        id: 993,
        btnType: 'warning',
        icon: 'el-icon-upload2'
      }
      const exportIdx = this.buttonList.findIndex(item => item.Func === 'exportStudentPhotosZip')
      if (exportIdx >= 0) {
        this.buttonList.splice(exportIdx + 1, 0, importBtn)
      } else {
        this.buttonList.push(importBtn)
      }
    } else {
      this.ensurePhotoImportAfterExport()
    }
    this.refreshOssAvatarMigrateEnabled()
    this.loadCurrentSchoolSchType()
    this.$nextTick(() => this.relayoutPersonTable())
    window.addEventListener('resize', this.relayoutPersonTable)
  },
  beforeDestroy() {
    this.clearPhotoExportProgress();
    this.clearPhotoImportProgress();
    window.removeEventListener('resize', this.relayoutPersonTable)
  },
};
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.avatar-size-tip {
  margin-top: 8px;
  color: #606266;
  font-size: 12px;
  line-height: 1.2;
}

.avatar-size-tip.is-over {
  color: #f56c6c;
}

/* ... 已有代码 ... */
.statistics {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 20px;
}

/* 无头像人数统计胶囊标签（对齐设计图：浅粉背景、粉红边框与文字、圆角胶囊、点击自动筛选） */
.stat-no-avatar-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 14px;
  border-radius: 999px;
  font-size: 13px;
  line-height: 20px;
  color: #f56c6c;
  background-color: #fff2f2;
  border: 1px solid #fde2e2;
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
}

.stat-no-avatar-pill:hover {
  background-color: #fde2e2;
  border-color: #fca5a5;
  box-shadow: 0 2px 6px rgba(245, 108, 108, 0.18);
  transform: translateY(-1px);
}

.stat-no-avatar-pill.is-active {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(245, 108, 108, 0.35);
}

.avatar-wrapper {
  position: relative;
  width: 106.8px;
  height: 106.8px;
}

.avatar-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 6px;
}

.avatar-wrapper:hover .avatar-mask {
  opacity: 1;
}

.avatar-mask i {
  font-size: 24px;
  cursor: pointer;
}

.user-form-tabs /deep/ .el-tabs__content {
  padding: 0;
  overflow: hidden;
}

.user-form-tab-pane {
  max-height: 52vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px 10px 4px;
  box-sizing: border-box;
}

.voip-auth-link {
  padding: 0;
}

.duplicate-table {
  width: 100% !important;
}

.duplicate-table .cell {
  padding-left: 6px;
  padding-right: 6px;
}

.duplicate-table .duplicate-col-suggest .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.duplicate-table .duplicate-col-action .cell {
  padding-left: 10px;
  padding-right: 12px;
}

.duplicate-del-btn {
  color: #F56C6C !important;
  padding: 0 4px;
}
.duplicate-del-btn:hover,
.duplicate-del-btn:focus {
  color: #f78989 !important;
}

.duplicate-risk-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  align-items: flex-start;
  /* 勿限高裁切，否则「无监护人」等标签下边框会被切掉。最后更新：2026-09-15 */
  line-height: 1.2;
  padding: 1px 0;
}

.duplicate-risk-tag {
  margin: 0;
  max-width: 100%;
}

.duplicate-tip {
  color: #606266;
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 1.6;
}

.duplicate-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.duplicate-search {
  width: 280px;
  max-width: 100%;
}

.duplicate-scope-switch {
  margin-left: 4px;
}

.duplicate-scope-switch >>> .el-switch__label {
  color: #909399;
  font-size: 12px;
}

.duplicate-scope-switch >>> .el-switch__label.is-active {
  color: #409eff;
}

.duplicate-summary {
  margin-left: auto;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* 固定列表区高度，翻页 loading 时不再塌陷。最后更新：2026-09-15 */
.duplicate-list-panel {
  height: 52vh;
  min-height: 360px;
  max-height: 560px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 4px 8px;
  box-sizing: border-box;
  position: relative;
}

.duplicate-collapse {
  min-height: 100%;
}

.duplicate-group-title {
  margin-right: 8px;
  font-weight: 600;
}
.duplicate-ding-btn {
  margin-left: 10px;
  color: #409EFF;
}
.duplicate-merge-btn {
  margin-left: 4px;
  color: #E6A23C;
}
.duplicate-ding-summary {
  margin-left: 10px;
  font-size: 12px;
  color: #606266;
  font-weight: normal;
  max-width: 58%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  vertical-align: middle;
  line-height: 1.35;
}

.duplicate-ding-line {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.duplicate-ding-uid {
  margin-left: 4px;
  font-style: normal;
  color: #409EFF;
  font-weight: 600;
}

.duplicate-pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.duplicate-parent-link {
  padding: 0;
  font-weight: 600;
}

.duplicate-parent-mismatch {
  color: #e6a23c;
  margin-left: 2px;
}
</style>

<style>
/* append-to-body 弹窗需非 scoped。创建于 2026-09-03 */
.duplicate-student-dialog {
  max-width: 96vw;
}
.duplicate-student-dialog .el-dialog__body {
  padding: 12px 16px 8px;
  display: flex;
  flex-direction: column;
}
.duplicate-student-dialog .duplicate-list-panel {
  flex: 1 1 auto;
}
</style>
